import { SetStateAction, useContext, useEffect, useState } from "react";
import { AuthContext, AuthContextType, LoadingContext, LoadingContextType, ToastContext, ToastContextType, useAsync, useRequiredParams } from "../../utilities/customHooks";
import { Payment, SowItem } from "../../utilities/frontendTypes";
import Button, { ButtonProp } from "../../Components/Button";
import moment from "moment";
import { serviceProviderSubmitSow, serviceProviderSaveProgressSow } from "../../services/serviceProvider";
import * as T from "../../utilities/frontendTypes";
import { useNavigate } from 'react-router-dom';
import DatePicker from 'react-datepicker';
import "react-datepicker/dist/react-datepicker.css";
import { handleFormSaveResponse } from "../../utilities/helperFunctions";
import { v4 as uuidv4 } from 'uuid';
import { inputClasses } from "../../Components/Form/InputField";
import Modal from "../../Components/Modal";
import PdfDownloader from "../../Components/Form/pdfDisplayProvider";

const CreateSOW = ({sowDetails} : {sowDetails: T.SowRequestDetails}) => {
  const navigate = useNavigate();
  const { logout } = useContext(AuthContext) as AuthContextType;
  const showToast = (useContext(ToastContext) as ToastContextType).showToast;
  const {showLoading, hideLoading} = useContext(LoadingContext) as LoadingContextType;
  const date = new Date()
  const [isAddingMilestone, setIsAddingMilestone] = useState(false)
  const [sowItemTableHtml, setSowItemTableHtml] = useState<React.ReactNode | null>(null);
  const [deliverableDateMin, setDeliverableDateMin] = useState<Date>(sowDetails.sowItemArray.length > 0 ? new Date(sowDetails.sowItemArray[0].itemDate) : new Date())
  const [finalPayDateMin, setFinalPayDateMin] = useState<Date>(sowDetails.sowItemArray.length > 0 ? new Date(sowDetails.sowItemArray[sowDetails.sowItemArray.length - 1].itemDate) : new Date())
  const [milestonePayDateMin, setMilestonePayDateMin] = useState<Date>(sowDetails.sowItemArray.length > 0 ? new Date(sowDetails.sowItemArray[0].itemDate) : new Date())
  // const [postMileStoneDate, setPostMileStoneDate] = useState<Date>(new Date())
  const [coInvestDate, setCoInvestDate] = useState<Date>(new Date())
  const [coInvestAmount, setCoInvestAmount] = useState<number>(0)
  const [currentTotal, setCurrentTotal] = useState<number>(0)
  const [currentTax, setCurrentTax] = useState<number>(0)
  const [paymentDate, setPaymentDate] = useState<Date>(sowDetails.sowItemArray.length > 0 ? new Date(sowDetails.sowItemArray[0].itemDate) : new Date())
  const [coPaymentDate, setCoPaymentDate] = useState<Date>(sowDetails.sowItemArray.length > 0 ? new Date(sowDetails.sowItemArray[0].itemDate) : new Date())
  const [isAddingFinal, setIsAddingFinal] =  useState(false)
  const [finalTotal, setFinalTotal] = useState<number>(0)
  const [sowItemArray, setSowItemArray] = useState<SowItem[]>(sowDetails.sowItemArray) 
  const [paymentArray, setPaymentArray] = useState<Payment[]>(sowDetails.paymentArray)
  const [combinedPaySowArray, setCombinedPaySowArray] = useState<(SowItem | Payment)[]>(sowDetails.sowItemArray.length > 0 ? [...sowItemArray, ...paymentArray].sort((a, b) => new Date(a.itemDate).getTime() - new Date(b.itemDate).getTime()) : [] )
  const [editingItem, setEditingItem] = useState<(SowItem | Payment | {})>({})
  const [addingItem, setAddingItem] = useState(false)
  const [expenses, setExpenses] = useState<{
    expenseId: string,
    itemDescription: string;
    isLumpsum: boolean;
    effort: string;
    hourlyRate: string;
    amount: string;
    tax: string;
  }[]>([]);
  const [description, setDescription] = useState(sowDetails.description);
  const [isLumpsum, setIsLumpsum] = useState(false)
  const [itemDescription, setItemDescription] = useState("");
  const [title, setTitle] = useState(sowDetails.title || "");
  const [amount, setAmount] = useState('');
  const [tax, setTax] = useState('');
  const [hourlyRate, setHourlyRate] = useState("");
  const [category, setCategory] = useState<string>("");
  const [task, setTask] = useState<string>("");
  const [taskDescription, setTaskDescription] = useState(''); 
  const [effort, setEffort] = useState("");
  const [deliverable, setDeliverable] = useState("");
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [deliveryDate, setDeliveryDate] = useState<Date>(sowDetails.sowItemArray.length > 0 ? new Date(sowDetails.sowItemArray[0].itemDate) : new Date())
  const [editingDate, setEditingDate] = useState<Date>(new Date());
  const [paymentDisabled, setPaymentDisabled] = useState(true)
  const [isEditing, setIsEditing] = useState(false)
  const [editPayType, setEditPayType] = useState("")
  const [modalHtml, setModalHtml] = useState(<></>)
  const isTier2 = sowDetails.tier === "2" ? true : false
  const coInvestPercentage = sowDetails.coPayPercentage
  const [viewingStartupFeedback, setViewingStartupFeedback] = useState(false)
  const [viewingAdminFeedback, setViewingAdminFeedback] = useState(false)
  const [feedbackViewed, setFeedbackViewed] = useState(false)
  const [viewingGuidelines, setViweingGuidelines] = useState(false)

  const pageTitleString = (sowStatus: string) => {
    if (sowStatus === "New SoW Request") {
      return "Create New SoW"
    }
    if (sowStatus === "Unsubmitted SoW") {
      return "Resume Creating SoW"
    }
    if (sowStatus === "") {
      return ""
    }
    if (sowStatus === "") {
      return ""
    }
  }

  const parsedNotes = sowDetails.startupFeedback?.map(note => ({
        ...note,
        date: new Date(note.date)
    }));
    
  const sortedNotes = parsedNotes?.sort((a, b) => b.date.getTime() - a.date.getTime());

  const startupFeedbackHtml = (
    <div>
      {sortedNotes?.map((note, index) => (
        <div key={index}>
          <div className="flex justify-between w-full mb-2">
            <p>{moment(note.date).format('MMM Do YYYY').toString()}</p>
          </div>
          <div className="flex mt-2 mb-2">
            <span className="notesLine">{note.feedback}</span>
          </div>
        </div>
      ))}
    </div>
  )

  const adminParsedNotes = sowDetails.adminFeedback?.map(note => ({
    ...note,
    date: new Date(note.date)
  }));

  const adminSortedNotes = adminParsedNotes?.sort((a, b) => b.date.getTime() - a.date.getTime());
console.log(sowDetails)
  const adminFeedbackHtml = (
    <div>
      {adminSortedNotes?.map((note, index) => (
        <div key={index}>
          <div className="flex justify-between w-full mb-2">
            <p>{moment(note.date).format('MMM Do YYYY').toString()}</p>
          </div>
          <div className="flex mt-2 mb-2">
            <span className="notesLine">{note.feedback}</span>
          </div>
        </div>
      ))}
    </div>
  )

  const viewStartupFeedback = () => {
    setViewingStartupFeedback(true)
    setIsModalOpen(true)
    setFeedbackViewed(true)
  }

  if (sowDetails.sowStatus === "Edit Request from Startup" && feedbackViewed === false) {
    viewStartupFeedback()
  }

  const viewAdminFeedback = () => {
    setViewingAdminFeedback(true)
    setIsModalOpen(true)
    setFeedbackViewed(true)
  }

  const finalPayment = paymentArray.find(item => item.paymentType === "final");
  const finalPaymentDate = finalPayment ? finalPayment.itemDate : null
  if (sowDetails.sowStatus === "Edit Requested from Admin" && feedbackViewed === false) {
    viewAdminFeedback()
  }
  

  const closeModalFunc = () => {
    setIsModalOpen(false)
    setViewingStartupFeedback(false)
    setViewingAdminFeedback(false)
    setFeedbackViewed(true)
  }  

  const scrollToElement = (elementId: string) => {
    const element = document.getElementById(elementId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  const addingItemDisplay = () => {

    setAddingItem(true)
    scrollToElement("AddingItemCont")
  }
  const handleEditingItem = (itemId: string | undefined) => { 
    const finalPayment = paymentArray.find(item => item.paymentType === "final");
 
    if (sowItemArray && sowItemArray.some(item => item.itemId === itemId)) {
      const editItem = sowItemArray.find(item => item.itemId === itemId)
      if (editItem) {
        setEditingItem(editItem)
        setCategory(editItem.category)
        setTask(editItem.task)
        setTaskDescription(editItem.taskDescription)
        setDeliverable(editItem.deliverable)
        setEditingDate(new Date(editItem.itemDate))
        setExpenses(editItem.costBreakdown)
      }
      setIsEditing(true)
      scrollToElement("EditItemCont")
    } else if (paymentArray.some(item => item.itemId === itemId)) {
      const editItem = paymentArray.find(item => item.itemId === itemId)
      if (editItem && editItem.paymentType) {
        setEditPayType(editItem.paymentType)
        setEditingItem(editItem)
        setEditingDate(new Date(editItem.itemDate))
      }
      setIsEditing(true)
      scrollToElement("EditItemCont")
    }
  }

  const handleSaveEdit = () => {
    console.log(editingItem)
    if (editingItem.hasOwnProperty("category")) {
      const item = editingItem as SowItem
      const itemId = item.itemId
      if (sowItemArray && sowItemArray.some(item => item.itemId === itemId)) {
        const costBreakdownTotal = expenses.reduce((total, item) => total + parseFloat(item.amount), 0);
        const costBreakdownTotalTax = expenses.reduce((total, item) => {
          if (item.tax) {
            return total + (parseFloat(item.amount) * parseFloat(item.tax))
          } 
          return total;
        }, 0)
        handleAddExpense
        const editedItem = {
          category,
          task,
          taskDescription,
          deliverable,
          itemDate: deliveryDate,
          costBreakdown: expenses,
          itemId,
          costBreakdownTotal,
          costBreakdownTotalTax
        }
        if (itemDescription && amount && tax) {
          const expenseId = uuidv4()
          const newExpense = { itemDescription, amount, tax, hourlyRate, isLumpsum, effort, expenseId };
          editedItem.costBreakdown = ([...editedItem.costBreakdown, newExpense]);
        }
        const index = sowItemArray.findIndex(item => item.itemId === itemId);
        if (index !== -1) {
          const newArray = [...sowItemArray]
          newArray[index] = editedItem
          setIsEditing(false)
          setCategory("")
          setSowItemArray(newArray)
          setExpenses([])
          setTax("")
          setAmount("")
          setItemDescription("")
          setAddingItem(false)
          setCategory("");
          setTaskDescription('');
          setTask('');
          setDeliverable("");
          setHourlyRate('')
          setIsLumpsum(false)
          setHourlyRate('')
          setEffort('');
          setItemDescription('');
          setHourlyRate('')
          setAmount('');
          setTax('');
          setEffort('');
          setIsLumpsum(false);
        }
      }
    } else if (editingItem.hasOwnProperty("paymentType")) {
      console.log("hdhdhdfh")
      const item = editingItem as Payment
      item.itemDate = paymentDate
      const itemId = item.itemId
      if (paymentArray && paymentArray.some(item => item.itemId === itemId)) {
        const index = paymentArray.findIndex(item => item.itemId === itemId);
        if (index !== -1) {
          const newArray = [...paymentArray]
          newArray[index] = item
          setPaymentArray(newArray)
          setIsEditing(false)
        }
      }
    }
  }

  const handleRemove = (itemId: string | undefined) => {{
     if (sowItemArray.some(item => item.itemId === itemId)) {
      const removedSowItemArray = sowItemArray.filter(item => item.itemId !== itemId);
      if (removedSowItemArray.length === 0) {
        setDeliverableDateMin(new Date())
        setDeliveryDate(new Date())
      }
      setSowItemArray(removedSowItemArray)
    } else if (paymentArray.some(item => item.itemId === itemId)) {
      const removedPayItemArray = paymentArray.filter(item => item.itemId !== itemId);
      setPaymentArray(removedPayItemArray)
    } else {
      console.log(`Item with ID ${itemId} not found in either array`);
    }
  }
  }

  const removeExpense = (itemId: string | undefined) => {
    if (expenses.some(item => item.expenseId === itemId)) {
      const removedExpenseArray = expenses.filter(item => item.expenseId !== itemId);
      setExpenses(removedExpenseArray)
    } 
  }

  useEffect(() => {
    const combinedArray = [...sowItemArray, ...paymentArray];
    const sortedArray = combinedArray.sort((a, b) => new Date(a.itemDate).getTime() - new Date(b.itemDate).getTime());
    let totalMilestoneCost = 0;
    let totalMilestoneTax = 0;
    // let totalFinalCost = 0;
    // let totalFinalTax = 0;
    sortedArray.forEach((item, index) => {
      // If the item is a sowItem
      if (item.hasOwnProperty('category')) {
        let sowItem = item as SowItem
          // Add costBreakdownTotal to totalCost and costBreakdownTotalTax to totalTax
        totalMilestoneCost += sowItem.costBreakdownTotal;
        totalMilestoneTax += sowItem.costBreakdownTotalTax;
        // totalFinalCost += sowItem.costBreakdownTotal;
        // totalFinalTax += sowItem.costBreakdownTotalTax;
      } else if (item.hasOwnProperty('paymentType')) {
        let payment = item as Payment
        if (payment.paymentType === "milestone") {
        payment.itemDate = item.itemDate
        payment.itemId = item.itemId
        payment.tax = totalMilestoneTax;
        payment.preTax = totalMilestoneCost;
        payment.paymentAmount = totalMilestoneCost + totalMilestoneTax;
        totalMilestoneCost = 0;
        totalMilestoneTax = 0;
        } else if (payment.paymentType === "final") {
          payment.tax = totalMilestoneTax;
          payment.preTax = totalMilestoneCost;
          payment.paymentAmount = totalMilestoneCost + totalMilestoneTax;
        }
      }
    });
    setCombinedPaySowArray(sortedArray)
  }, [sowItemArray, paymentArray]);

  useEffect(() => {
    if(combinedPaySowArray.length > 0 && combinedPaySowArray[combinedPaySowArray.length - 1].hasOwnProperty('category')) {
      setPaymentDisabled(false)
    } else {
      setPaymentDisabled(true)
    }
    if(combinedPaySowArray.length > 0) {
      setDeliverableDateMin(combinedPaySowArray[combinedPaySowArray.length - 1].itemDate)
    }
    const generateSowItemTableHtml = () => {
      const html = combinedPaySowArray.map((item, index) => {
      if (item.hasOwnProperty('category')) {
        const {category, task, taskDescription, deliverable, itemDate, costBreakdown, costBreakdownTotalTax, costBreakdownTotal, itemId} = item as SowItem;
        // updateCurrentTotal(costBreakdownTotal)
        // updateCurrentTax(costBreakdownTotalTax)
        return (
          <div key={itemId} className="w-full flex gap-2 relative mb-4 mt-4  border-cSage border-b-[1px]">
            <div className="h-full flex flex-col justify-between" style={{ width: '15%', display: 'inline-flex' }}>
              <div className="mb-4">
                <p className="flex grow break-word font-normal text-text/80 self-center capitalize">{category}</p>
                <p className="flex grow break-word font-normal text-text/80 self-center capitalize mt-2">{task}</p>
              </div>
              <div className={`flex flex-col gap-2 pb-2 modalHide ${isModalOpen ? "hidden" : ""}`}>
                <button onClick={() => handleEditingItem(itemId)} className="hover:underline flex gap-2 items-center w-fit">
                  <svg xmlns="http://www.w3.org/2000/svg" width="17" height="17" viewBox="0 0 17 17" fill="none"><path d="M1.5835 16.1949C1.92197 16.3949 2.30814 16.4987 2.70448 16.4987H13.0426C14.2589 16.4987 15.2517 15.5091 15.2517 14.2914V6.72883C15.2517 6.56324 15.1172 6.42889 14.9515 6.42889C14.7858 6.42889 14.6513 6.56324 14.6513 6.72883V14.2914C14.6513 15.1771 13.9306 15.8989 13.0425 15.8989H2.70365C2.4152 15.8989 2.133 15.8231 1.88912 15.6786C1.65304 15.5388 1.45448 15.3404 1.3169 15.1068C1.17306 14.8631 1.09645 14.5812 1.09645 14.2929V5.50083C1.09645 5.33289 1.12225 5.16885 1.17462 5.01109H2.81152C3.32979 5.01109 3.75426 4.58929 3.75426 4.06909V2.43346C3.91216 2.38347 4.07633 2.3577 4.24439 2.3577H10.2721C10.4379 2.3577 10.5723 2.22335 10.5723 2.05775C10.5723 1.89216 10.4379 1.75781 10.2721 1.75781H4.24439C3.92858 1.75781 3.6237 1.82342 3.33995 1.95153H3.3337C3.09528 2.05541 2.87719 2.20772 2.68332 2.40144L1.14413 3.93942C0.950269 4.13313 0.800171 4.35106 0.69621 4.5854V4.5893C0.69621 4.59164 0.693865 4.59555 0.692301 4.59711C0.564102 4.88144 0.5 5.18528 0.5 5.49928V14.2914C0.5 14.6874 0.606313 15.0733 0.804079 15.4115C0.994035 15.7333 1.26607 16.0035 1.58892 16.1957L1.5835 16.1949ZM1.56552 4.36279L3.1047 2.82481C3.12034 2.80919 3.13441 2.79669 3.15082 2.78263V4.06832C3.15082 4.25657 2.99683 4.41043 2.80844 4.41043H1.52174C1.53582 4.39481 1.54989 4.37841 1.56396 4.36435L1.56552 4.36279Z" fill="#1A2E25"/><path d="M14.7319 0.503202C14.2598 0.503202 13.8134 0.687543 13.4788 1.02106L4.69628 9.79757C4.50242 9.99128 4.3539 10.2295 4.26791 10.4896L3.33768 13.2773C3.30172 13.3851 3.32987 13.503 3.4096 13.5835C3.46745 13.6413 3.54405 13.6717 3.62144 13.6717C3.65349 13.6717 3.68554 13.6655 3.71525 13.6561L6.50509 12.7266C6.7654 12.6407 7.00304 12.4923 7.19768 12.2986L15.981 3.52206C16.3156 3.18774 16.4993 2.74409 16.4993 2.26996C16.4993 1.79583 16.3148 1.35218 15.981 1.01786C15.6465 0.683544 15.2025 0.5 14.728 0.5L14.7319 0.503202ZM6.77565 11.8768C6.64745 12.0049 6.48954 12.1025 6.31756 12.1588L4.09585 12.8985L4.83612 10.6785C4.89397 10.5067 4.99012 10.3489 5.11833 10.2208L12.3406 3.00418L13.9955 4.65776L6.7732 11.8744L6.77565 11.8768ZM14.4223 4.23688L12.7675 2.5833L12.9637 2.38724L14.6186 4.04082L14.4223 4.23688ZM15.5605 3.09882L15.0422 3.61668L13.3874 1.9631L13.9056 1.44524C14.1261 1.22496 14.42 1.10313 14.7342 1.10313C15.0485 1.10313 15.3408 1.22498 15.5629 1.44524C15.7833 1.66552 15.9052 1.9592 15.9052 2.2732C15.9052 2.5872 15.7833 2.87932 15.5629 3.10116L15.5605 3.09882Z" fill="#1A2E25"/></svg>
                  <p>Edit</p>
                </button>
                <button onClick={() => handleRemove(itemId)} className="hover:underline flex gap-2 items-center w-fit">
                  <svg xmlns="http://www.w3.org/2000/svg" width="17" height="17" viewBox="0 0 17 17" fill="none"><path d="M16.1323 3.07774H0.86766C0.661711 3.07774 0.5 2.92399 0.5 2.72899C0.5 2.53399 0.661716 2.38086 0.86766 2.38086H16.1323C16.3383 2.38086 16.5 2.53398 16.5 2.72899C16.5 2.92399 16.3383 3.07774 16.1323 3.07774Z" fill="#1A2E25"/><path d="M10.7557 2.94497C10.5425 1.92809 9.59329 1.19617 8.50489 1.19617C7.40852 1.19617 6.45943 1.92805 6.24618 2.94497L5.52539 2.8056C5.80459 1.4681 7.06269 0.5 8.50496 0.5C9.94653 0.5 11.1974 1.46813 11.4845 2.8056L10.7557 2.94497Z" fill="#1A2E25"/><path d="M13.4622 16.4994H3.53867C2.97233 16.4994 2.47927 16.0394 2.4423 15.4756L1.68454 3.40382C1.67002 3.20881 1.82447 3.04881 2.03042 3.03507C2.2291 3.01444 2.40534 3.16757 2.42052 3.36257L3.18553 15.4338C3.20005 15.6356 3.36177 15.8031 3.54592 15.8031H13.4621C13.6463 15.8031 13.808 15.6363 13.8225 15.4338L14.5876 3.36257C14.6021 3.16756 14.779 3.0282 14.9776 3.03507C15.1836 3.04882 15.338 3.20944 15.3235 3.40444L14.5585 15.4756C14.5143 16.0538 14.0364 16.4994 13.4622 16.4994Z" fill="#1A2E25"/><path d="M5.70735 13.9436C5.51594 13.9436 5.35423 13.7973 5.33969 13.6161L4.85455 5.31289C4.83936 5.12476 4.99382 4.95788 5.19977 4.95101C5.39845 4.93039 5.57469 5.09039 5.58986 5.27852L6.08294 13.5817C6.09746 13.7767 5.93575 13.9367 5.73706 13.9511C5.72254 13.9436 5.71527 13.9436 5.70735 13.9436Z" fill="#1A2E25"/><path d="M11.2924 13.9433H11.2707C11.0647 13.9296 10.9103 13.769 10.9248 13.574L11.4178 5.27077C11.4324 5.07577 11.602 4.92265 11.8079 4.94327C12.0139 4.95702 12.1683 5.11764 12.1538 5.31265L11.6608 13.6158C11.6449 13.804 11.4832 13.9433 11.2924 13.9433Z" fill="#1A2E25"/><path d="M8.50309 13.9437C8.29714 13.9437 8.13543 13.7906 8.13543 13.5956L8.13477 5.2993C8.13477 5.10429 8.29648 4.95117 8.50243 4.95117C8.70837 4.95117 8.87008 5.1043 8.87008 5.2993L8.87074 13.5956C8.87074 13.7906 8.70111 13.9437 8.50309 13.9437Z" fill="#1A2E25"/></svg>
                  <p>Remove</p>
                </button>
              </div>
            </div>
            <div className="h-full " style={{ width: '24%', display: 'inline-block' }}>
              <p className="">{taskDescription}</p>
            </div>
            <div className="h-full " style={{ width: '24%', display: 'inline-block' }}>
              <p className="">{deliverable}</p>
            </div>
            {/* <div className="h-full " style={{ width: '12%', display: 'inline-block' }}>
              <p className="">{effort}</p>
            </div> */}
            <div className="h-full " style={{ width: '12%', display: 'inline-block' }}>
              <p className="">{moment(itemDate).format('MMM Do YYYY').toString()}</p>
            </div>
            <div className="h-full mb-4" style={{ width: '24%', display: 'inline-block' }}>
              <ul className="w-full">
                {costBreakdown.map((expense, index) => (
                  <li key={index} className={index === 0 ? `expenseLi w-full !p-0 border-1 border-b mb-2 border-cSage` : "expenseLi border-1 border-b !p-0 mb-2 border-cSage"}>
                    <div>
                      {expense.itemDescription}
                    </div> 
                    {
                      !expense.isLumpsum &&
                      <div className="flex w-full bodySmaller">
                        <span className="w-1/3">Hours: {expense.effort}</span>
                        <span className="w-2/3">Hourly Rate: ${expense.hourlyRate}</span>
                      </div>                           
                    }
                    <div className="flex w-full bodySmaller pb-2">
                      <span className="w-1/3">$ {expense.amount}</span>
                      <span className="w-2/3">{expense.tax === "0" ? "No Tax" : expense.tax === "0.05" ? `5% tax =  $ ${((parseFloat(expense.amount) * (parseFloat(expense.tax))) + parseFloat(expense.amount)).toFixed(2)}` : `13% tax =  $ ${((parseFloat(expense.amount) * (parseFloat(expense.tax))) + parseFloat(expense.amount)).toFixed(2)}`}  </span>
                    </div>
                  </li>
                ))}
              </ul>
              <div className="flex flex-col gap-1">
                <p className="">Pre-Tax: ${costBreakdownTotal.toFixed(2)}</p>
                <p className="">Tax: ${costBreakdownTotalTax.toFixed(2)}</p>
                <p className=""><span className="font-semibold">Total: </span>${(costBreakdownTotal + costBreakdownTotalTax).toFixed(2)}</p>
              </div>
            </div>
          </div>
        );
      } else if (item.hasOwnProperty('paymentType')) {
          const {paymentType, itemDate, coInvestDate, paymentAmount, itemId, preTax, tax} = item as Payment
          if (paymentType === "milestone") {
            return (
              <div key={itemId} className="w-full pb-4 mb-4 gap-2 flex border-cSage border-b-[1px]">
                <div className="h-full flex-col" style={{ width: '64%', display: 'inline-flex' }}>
                  <p className="font-semibold mb-2">Progress Milestone Payment</p>
                  <div className={`flex flex-col gap-2 pb-2 modalHide ${isModalOpen ? "hide" : ""}`}>
                    <button onClick={() => handleEditingItem(itemId)} className="hover:underline flex gap-2 items-center w-fit">
                      <svg xmlns="http://www.w3.org/2000/svg" width="17" height="17" viewBox="0 0 17 17" fill="none"><path d="M1.5835 16.1949C1.92197 16.3949 2.30814 16.4987 2.70448 16.4987H13.0426C14.2589 16.4987 15.2517 15.5091 15.2517 14.2914V6.72883C15.2517 6.56324 15.1172 6.42889 14.9515 6.42889C14.7858 6.42889 14.6513 6.56324 14.6513 6.72883V14.2914C14.6513 15.1771 13.9306 15.8989 13.0425 15.8989H2.70365C2.4152 15.8989 2.133 15.8231 1.88912 15.6786C1.65304 15.5388 1.45448 15.3404 1.3169 15.1068C1.17306 14.8631 1.09645 14.5812 1.09645 14.2929V5.50083C1.09645 5.33289 1.12225 5.16885 1.17462 5.01109H2.81152C3.32979 5.01109 3.75426 4.58929 3.75426 4.06909V2.43346C3.91216 2.38347 4.07633 2.3577 4.24439 2.3577H10.2721C10.4379 2.3577 10.5723 2.22335 10.5723 2.05775C10.5723 1.89216 10.4379 1.75781 10.2721 1.75781H4.24439C3.92858 1.75781 3.6237 1.82342 3.33995 1.95153H3.3337C3.09528 2.05541 2.87719 2.20772 2.68332 2.40144L1.14413 3.93942C0.950269 4.13313 0.800171 4.35106 0.69621 4.5854V4.5893C0.69621 4.59164 0.693865 4.59555 0.692301 4.59711C0.564102 4.88144 0.5 5.18528 0.5 5.49928V14.2914C0.5 14.6874 0.606313 15.0733 0.804079 15.4115C0.994035 15.7333 1.26607 16.0035 1.58892 16.1957L1.5835 16.1949ZM1.56552 4.36279L3.1047 2.82481C3.12034 2.80919 3.13441 2.79669 3.15082 2.78263V4.06832C3.15082 4.25657 2.99683 4.41043 2.80844 4.41043H1.52174C1.53582 4.39481 1.54989 4.37841 1.56396 4.36435L1.56552 4.36279Z" fill="#1A2E25"/><path d="M14.7319 0.503202C14.2598 0.503202 13.8134 0.687543 13.4788 1.02106L4.69628 9.79757C4.50242 9.99128 4.3539 10.2295 4.26791 10.4896L3.33768 13.2773C3.30172 13.3851 3.32987 13.503 3.4096 13.5835C3.46745 13.6413 3.54405 13.6717 3.62144 13.6717C3.65349 13.6717 3.68554 13.6655 3.71525 13.6561L6.50509 12.7266C6.7654 12.6407 7.00304 12.4923 7.19768 12.2986L15.981 3.52206C16.3156 3.18774 16.4993 2.74409 16.4993 2.26996C16.4993 1.79583 16.3148 1.35218 15.981 1.01786C15.6465 0.683544 15.2025 0.5 14.728 0.5L14.7319 0.503202ZM6.77565 11.8768C6.64745 12.0049 6.48954 12.1025 6.31756 12.1588L4.09585 12.8985L4.83612 10.6785C4.89397 10.5067 4.99012 10.3489 5.11833 10.2208L12.3406 3.00418L13.9955 4.65776L6.7732 11.8744L6.77565 11.8768ZM14.4223 4.23688L12.7675 2.5833L12.9637 2.38724L14.6186 4.04082L14.4223 4.23688ZM15.5605 3.09882L15.0422 3.61668L13.3874 1.9631L13.9056 1.44524C14.1261 1.22496 14.42 1.10313 14.7342 1.10313C15.0485 1.10313 15.3408 1.22498 15.5629 1.44524C15.7833 1.66552 15.9052 1.9592 15.9052 2.2732C15.9052 2.5872 15.7833 2.87932 15.5629 3.10116L15.5605 3.09882Z" fill="#1A2E25"/></svg>
                      <p>Edit</p>
                    </button>
                    <button onClick={() => handleRemove(itemId)} className="hover:underline flex gap-2 items-center w-fit">
                      <svg xmlns="http://www.w3.org/2000/svg" width="17" height="17" viewBox="0 0 17 17" fill="none"><path d="M16.1323 3.07774H0.86766C0.661711 3.07774 0.5 2.92399 0.5 2.72899C0.5 2.53399 0.661716 2.38086 0.86766 2.38086H16.1323C16.3383 2.38086 16.5 2.53398 16.5 2.72899C16.5 2.92399 16.3383 3.07774 16.1323 3.07774Z" fill="#1A2E25"/><path d="M10.7557 2.94497C10.5425 1.92809 9.59329 1.19617 8.50489 1.19617C7.40852 1.19617 6.45943 1.92805 6.24618 2.94497L5.52539 2.8056C5.80459 1.4681 7.06269 0.5 8.50496 0.5C9.94653 0.5 11.1974 1.46813 11.4845 2.8056L10.7557 2.94497Z" fill="#1A2E25"/><path d="M13.4622 16.4994H3.53867C2.97233 16.4994 2.47927 16.0394 2.4423 15.4756L1.68454 3.40382C1.67002 3.20881 1.82447 3.04881 2.03042 3.03507C2.2291 3.01444 2.40534 3.16757 2.42052 3.36257L3.18553 15.4338C3.20005 15.6356 3.36177 15.8031 3.54592 15.8031H13.4621C13.6463 15.8031 13.808 15.6363 13.8225 15.4338L14.5876 3.36257C14.6021 3.16756 14.779 3.0282 14.9776 3.03507C15.1836 3.04882 15.338 3.20944 15.3235 3.40444L14.5585 15.4756C14.5143 16.0538 14.0364 16.4994 13.4622 16.4994Z" fill="#1A2E25"/><path d="M5.70735 13.9436C5.51594 13.9436 5.35423 13.7973 5.33969 13.6161L4.85455 5.31289C4.83936 5.12476 4.99382 4.95788 5.19977 4.95101C5.39845 4.93039 5.57469 5.09039 5.58986 5.27852L6.08294 13.5817C6.09746 13.7767 5.93575 13.9367 5.73706 13.9511C5.72254 13.9436 5.71527 13.9436 5.70735 13.9436Z" fill="#1A2E25"/><path d="M11.2924 13.9433H11.2707C11.0647 13.9296 10.9103 13.769 10.9248 13.574L11.4178 5.27077C11.4324 5.07577 11.602 4.92265 11.8079 4.94327C12.0139 4.95702 12.1683 5.11764 12.1538 5.31265L11.6608 13.6158C11.6449 13.804 11.4832 13.9433 11.2924 13.9433Z" fill="#1A2E25"/><path d="M8.50309 13.9437C8.29714 13.9437 8.13543 13.7906 8.13543 13.5956L8.13477 5.2993C8.13477 5.10429 8.29648 4.95117 8.50243 4.95117C8.70837 4.95117 8.87008 5.1043 8.87008 5.2993L8.87074 13.5956C8.87074 13.7906 8.70111 13.9437 8.50309 13.9437Z" fill="#1A2E25"/></svg>
                      <p>Remove</p>
                    </button>
                  </div>
                </div>
                <div className="h-full items-center" style={{ width: '12%', display: 'inline-flex' }}>
                  <p className="">{moment(itemDate).format('MMM Do YYYY').toString()}</p>
                </div>
                <div className="h-full flex-col justify-center" style={{ width: '24%', display: 'inline-flex' }}>
                  <p className=""><span className="">{`Pre-Tax: `}</span> $ {preTax?.toFixed(2)}</p>
                  <p className=""><span className="">{`Tax: `}</span> $ {tax?.toFixed(2)}</p>
                  <p className=""><span className="font-semibold">{`Total: `}</span> ${paymentAmount?.toFixed(2)}</p>
                </div>
              </div>
            );
          } else if (paymentType === "final" && isTier2) {
            return (
              <div key={itemId} className="w-full gap-2 flex pb-4 mb-4 border-cSage border-b-[1px]">
                <div className="h-full flex-col " style={{ width: '64%', display: 'inline-flex' }}>
                  <p className="font-semibold mb-2">Final Payment</p>
                  <div className={`flex flex-col gap-2 pb-2 modalHide ${isModalOpen ? "hide" : ""}`}>
                    <button onClick={() => handleEditingItem(itemId)} className="hover:underline flex gap-2 items-center w-fit">
                      <svg xmlns="http://www.w3.org/2000/svg" width="17" height="17" viewBox="0 0 17 17" fill="none"><path d="M1.5835 16.1949C1.92197 16.3949 2.30814 16.4987 2.70448 16.4987H13.0426C14.2589 16.4987 15.2517 15.5091 15.2517 14.2914V6.72883C15.2517 6.56324 15.1172 6.42889 14.9515 6.42889C14.7858 6.42889 14.6513 6.56324 14.6513 6.72883V14.2914C14.6513 15.1771 13.9306 15.8989 13.0425 15.8989H2.70365C2.4152 15.8989 2.133 15.8231 1.88912 15.6786C1.65304 15.5388 1.45448 15.3404 1.3169 15.1068C1.17306 14.8631 1.09645 14.5812 1.09645 14.2929V5.50083C1.09645 5.33289 1.12225 5.16885 1.17462 5.01109H2.81152C3.32979 5.01109 3.75426 4.58929 3.75426 4.06909V2.43346C3.91216 2.38347 4.07633 2.3577 4.24439 2.3577H10.2721C10.4379 2.3577 10.5723 2.22335 10.5723 2.05775C10.5723 1.89216 10.4379 1.75781 10.2721 1.75781H4.24439C3.92858 1.75781 3.6237 1.82342 3.33995 1.95153H3.3337C3.09528 2.05541 2.87719 2.20772 2.68332 2.40144L1.14413 3.93942C0.950269 4.13313 0.800171 4.35106 0.69621 4.5854V4.5893C0.69621 4.59164 0.693865 4.59555 0.692301 4.59711C0.564102 4.88144 0.5 5.18528 0.5 5.49928V14.2914C0.5 14.6874 0.606313 15.0733 0.804079 15.4115C0.994035 15.7333 1.26607 16.0035 1.58892 16.1957L1.5835 16.1949ZM1.56552 4.36279L3.1047 2.82481C3.12034 2.80919 3.13441 2.79669 3.15082 2.78263V4.06832C3.15082 4.25657 2.99683 4.41043 2.80844 4.41043H1.52174C1.53582 4.39481 1.54989 4.37841 1.56396 4.36435L1.56552 4.36279Z" fill="#1A2E25"/><path d="M14.7319 0.503202C14.2598 0.503202 13.8134 0.687543 13.4788 1.02106L4.69628 9.79757C4.50242 9.99128 4.3539 10.2295 4.26791 10.4896L3.33768 13.2773C3.30172 13.3851 3.32987 13.503 3.4096 13.5835C3.46745 13.6413 3.54405 13.6717 3.62144 13.6717C3.65349 13.6717 3.68554 13.6655 3.71525 13.6561L6.50509 12.7266C6.7654 12.6407 7.00304 12.4923 7.19768 12.2986L15.981 3.52206C16.3156 3.18774 16.4993 2.74409 16.4993 2.26996C16.4993 1.79583 16.3148 1.35218 15.981 1.01786C15.6465 0.683544 15.2025 0.5 14.728 0.5L14.7319 0.503202ZM6.77565 11.8768C6.64745 12.0049 6.48954 12.1025 6.31756 12.1588L4.09585 12.8985L4.83612 10.6785C4.89397 10.5067 4.99012 10.3489 5.11833 10.2208L12.3406 3.00418L13.9955 4.65776L6.7732 11.8744L6.77565 11.8768ZM14.4223 4.23688L12.7675 2.5833L12.9637 2.38724L14.6186 4.04082L14.4223 4.23688ZM15.5605 3.09882L15.0422 3.61668L13.3874 1.9631L13.9056 1.44524C14.1261 1.22496 14.42 1.10313 14.7342 1.10313C15.0485 1.10313 15.3408 1.22498 15.5629 1.44524C15.7833 1.66552 15.9052 1.9592 15.9052 2.2732C15.9052 2.5872 15.7833 2.87932 15.5629 3.10116L15.5605 3.09882Z" fill="#1A2E25"/></svg>
                      <p>Edit</p>
                    </button>
                    <button onClick={() => handleRemove(itemId)} className="hover:underline flex gap-2 items-center w-fit">
                      <svg xmlns="http://www.w3.org/2000/svg" width="17" height="17" viewBox="0 0 17 17" fill="none"><path d="M16.1323 3.07774H0.86766C0.661711 3.07774 0.5 2.92399 0.5 2.72899C0.5 2.53399 0.661716 2.38086 0.86766 2.38086H16.1323C16.3383 2.38086 16.5 2.53398 16.5 2.72899C16.5 2.92399 16.3383 3.07774 16.1323 3.07774Z" fill="#1A2E25"/><path d="M10.7557 2.94497C10.5425 1.92809 9.59329 1.19617 8.50489 1.19617C7.40852 1.19617 6.45943 1.92805 6.24618 2.94497L5.52539 2.8056C5.80459 1.4681 7.06269 0.5 8.50496 0.5C9.94653 0.5 11.1974 1.46813 11.4845 2.8056L10.7557 2.94497Z" fill="#1A2E25"/><path d="M13.4622 16.4994H3.53867C2.97233 16.4994 2.47927 16.0394 2.4423 15.4756L1.68454 3.40382C1.67002 3.20881 1.82447 3.04881 2.03042 3.03507C2.2291 3.01444 2.40534 3.16757 2.42052 3.36257L3.18553 15.4338C3.20005 15.6356 3.36177 15.8031 3.54592 15.8031H13.4621C13.6463 15.8031 13.808 15.6363 13.8225 15.4338L14.5876 3.36257C14.6021 3.16756 14.779 3.0282 14.9776 3.03507C15.1836 3.04882 15.338 3.20944 15.3235 3.40444L14.5585 15.4756C14.5143 16.0538 14.0364 16.4994 13.4622 16.4994Z" fill="#1A2E25"/><path d="M5.70735 13.9436C5.51594 13.9436 5.35423 13.7973 5.33969 13.6161L4.85455 5.31289C4.83936 5.12476 4.99382 4.95788 5.19977 4.95101C5.39845 4.93039 5.57469 5.09039 5.58986 5.27852L6.08294 13.5817C6.09746 13.7767 5.93575 13.9367 5.73706 13.9511C5.72254 13.9436 5.71527 13.9436 5.70735 13.9436Z" fill="#1A2E25"/><path d="M11.2924 13.9433H11.2707C11.0647 13.9296 10.9103 13.769 10.9248 13.574L11.4178 5.27077C11.4324 5.07577 11.602 4.92265 11.8079 4.94327C12.0139 4.95702 12.1683 5.11764 12.1538 5.31265L11.6608 13.6158C11.6449 13.804 11.4832 13.9433 11.2924 13.9433Z" fill="#1A2E25"/><path d="M8.50309 13.9437C8.29714 13.9437 8.13543 13.7906 8.13543 13.5956L8.13477 5.2993C8.13477 5.10429 8.29648 4.95117 8.50243 4.95117C8.70837 4.95117 8.87008 5.1043 8.87008 5.2993L8.87074 13.5956C8.87074 13.7906 8.70111 13.9437 8.50309 13.9437Z" fill="#1A2E25"/></svg>
                      <p>Remove</p>
                    </button>
                  </div>
                </div>
                <div className="h-full items-center" style={{ width: '12%', display: 'inline-flex' }}>
                  <p className="">{moment(itemDate).format('MMM Do YYYY').toString()}</p>
                </div>
                <div className="h-full flex-col justify-center" style={{ width: '14%', display: 'inline-flex' }}>
                  <p className=""><span className="">{`Pre Tax: `}</span> $ {preTax?.toFixed(2)}</p>
                  <p className=""><span className="">{`Tax: `}</span> $ {tax?.toFixed(2)}</p>
                  <p className=""><span className="font-semibold">{`Total: `}</span> ${paymentAmount?.toFixed(2)}</p>
                </div>
            </div>
            )
          } else if (paymentType === "final" && !isTier2 && coInvestDate) {
            setCoInvestDate(coInvestDate);
            if (preTax) {
              setCoInvestAmount(coInvestPercentage / 100 * preTax)
            }
            return (
              <div className="w-full mb-4 gap-2 flex flex-col border-cSage border-b-[1px]">
                <div key={itemId} className="w-full gap-2 flex">
                  <div className="h-full items-center" style={{ width: '64%', display: 'inline-flex' }}>
                    <p className="font-semibold mb-2">Final Payment</p>
                  </div>
                  <div className="h-full items-center" style={{ width: '12%', display: 'inline-flex' }}>
                    <p className="">{moment(itemDate).format('MMM Do YYYY').toString()}</p>
                  </div>
                  <div className="h-full flex-col gap-2 justify-center border-cSage border-b-[1px]" style={{ width: '24%', display: 'inline-flex' }}>
                    <p className=""><span className="">{`Pre Tax: `}</span> $ {preTax?.toFixed(2)}</p>
                    <p className=""><span className="">{`Tax: `}</span> $ {tax?.toFixed(2)}</p>
                    <p className="pb-2"><span className="font-semibold">{`Total: `}</span> ${paymentAmount?.toFixed(2)}</p>
                  </div>
                </div>
                <div className="w-full flex gap-2 py-2">
                  <div className="h-full items-center" style={{ width: '64%', display: 'inline-flex' }}>
                    <p className="font-semibold">Co-Invest Payment ({coInvestPercentage}%)</p>
                  </div>
                  <div className="h-full items-center" style={{ width: '12%', display: 'inline-flex' }}>
                    <p className="">{moment(coInvestDate).format('MMM Do YYYY').toString()}</p>
                  </div>
                  <div className="h-full flex-col justify-center" style={{ width: '24%', display: 'inline-flex' }}>
                    <p className=""><span className="font-semibold">{`Total: `}</span> ${preTax ? (coInvestPercentage / 100 * preTax).toFixed(2) : ""}</p>
                  </div>
                </div>
                <div className={`w-full flex flex-col gap-2 pb-2 modalHide ${isModalOpen ? "hide" : ""}`}>
                  <button onClick={() => handleEditingItem(itemId)} className="hover:underline flex gap-2 items-center w-fit">
                    <svg xmlns="http://www.w3.org/2000/svg" width="17" height="17" viewBox="0 0 17 17" fill="none"><path d="M1.5835 16.1949C1.92197 16.3949 2.30814 16.4987 2.70448 16.4987H13.0426C14.2589 16.4987 15.2517 15.5091 15.2517 14.2914V6.72883C15.2517 6.56324 15.1172 6.42889 14.9515 6.42889C14.7858 6.42889 14.6513 6.56324 14.6513 6.72883V14.2914C14.6513 15.1771 13.9306 15.8989 13.0425 15.8989H2.70365C2.4152 15.8989 2.133 15.8231 1.88912 15.6786C1.65304 15.5388 1.45448 15.3404 1.3169 15.1068C1.17306 14.8631 1.09645 14.5812 1.09645 14.2929V5.50083C1.09645 5.33289 1.12225 5.16885 1.17462 5.01109H2.81152C3.32979 5.01109 3.75426 4.58929 3.75426 4.06909V2.43346C3.91216 2.38347 4.07633 2.3577 4.24439 2.3577H10.2721C10.4379 2.3577 10.5723 2.22335 10.5723 2.05775C10.5723 1.89216 10.4379 1.75781 10.2721 1.75781H4.24439C3.92858 1.75781 3.6237 1.82342 3.33995 1.95153H3.3337C3.09528 2.05541 2.87719 2.20772 2.68332 2.40144L1.14413 3.93942C0.950269 4.13313 0.800171 4.35106 0.69621 4.5854V4.5893C0.69621 4.59164 0.693865 4.59555 0.692301 4.59711C0.564102 4.88144 0.5 5.18528 0.5 5.49928V14.2914C0.5 14.6874 0.606313 15.0733 0.804079 15.4115C0.994035 15.7333 1.26607 16.0035 1.58892 16.1957L1.5835 16.1949ZM1.56552 4.36279L3.1047 2.82481C3.12034 2.80919 3.13441 2.79669 3.15082 2.78263V4.06832C3.15082 4.25657 2.99683 4.41043 2.80844 4.41043H1.52174C1.53582 4.39481 1.54989 4.37841 1.56396 4.36435L1.56552 4.36279Z" fill="#1A2E25"/><path d="M14.7319 0.503202C14.2598 0.503202 13.8134 0.687543 13.4788 1.02106L4.69628 9.79757C4.50242 9.99128 4.3539 10.2295 4.26791 10.4896L3.33768 13.2773C3.30172 13.3851 3.32987 13.503 3.4096 13.5835C3.46745 13.6413 3.54405 13.6717 3.62144 13.6717C3.65349 13.6717 3.68554 13.6655 3.71525 13.6561L6.50509 12.7266C6.7654 12.6407 7.00304 12.4923 7.19768 12.2986L15.981 3.52206C16.3156 3.18774 16.4993 2.74409 16.4993 2.26996C16.4993 1.79583 16.3148 1.35218 15.981 1.01786C15.6465 0.683544 15.2025 0.5 14.728 0.5L14.7319 0.503202ZM6.77565 11.8768C6.64745 12.0049 6.48954 12.1025 6.31756 12.1588L4.09585 12.8985L4.83612 10.6785C4.89397 10.5067 4.99012 10.3489 5.11833 10.2208L12.3406 3.00418L13.9955 4.65776L6.7732 11.8744L6.77565 11.8768ZM14.4223 4.23688L12.7675 2.5833L12.9637 2.38724L14.6186 4.04082L14.4223 4.23688ZM15.5605 3.09882L15.0422 3.61668L13.3874 1.9631L13.9056 1.44524C14.1261 1.22496 14.42 1.10313 14.7342 1.10313C15.0485 1.10313 15.3408 1.22498 15.5629 1.44524C15.7833 1.66552 15.9052 1.9592 15.9052 2.2732C15.9052 2.5872 15.7833 2.87932 15.5629 3.10116L15.5605 3.09882Z" fill="#1A2E25"/></svg>
                    <p>Edit</p>
                  </button>
                  <button onClick={() => handleRemove(itemId)} className="hover:underline flex gap-2 items-center w-fit">
                    <svg xmlns="http://www.w3.org/2000/svg" width="17" height="17" viewBox="0 0 17 17" fill="none"><path d="M16.1323 3.07774H0.86766C0.661711 3.07774 0.5 2.92399 0.5 2.72899C0.5 2.53399 0.661716 2.38086 0.86766 2.38086H16.1323C16.3383 2.38086 16.5 2.53398 16.5 2.72899C16.5 2.92399 16.3383 3.07774 16.1323 3.07774Z" fill="#1A2E25"/><path d="M10.7557 2.94497C10.5425 1.92809 9.59329 1.19617 8.50489 1.19617C7.40852 1.19617 6.45943 1.92805 6.24618 2.94497L5.52539 2.8056C5.80459 1.4681 7.06269 0.5 8.50496 0.5C9.94653 0.5 11.1974 1.46813 11.4845 2.8056L10.7557 2.94497Z" fill="#1A2E25"/><path d="M13.4622 16.4994H3.53867C2.97233 16.4994 2.47927 16.0394 2.4423 15.4756L1.68454 3.40382C1.67002 3.20881 1.82447 3.04881 2.03042 3.03507C2.2291 3.01444 2.40534 3.16757 2.42052 3.36257L3.18553 15.4338C3.20005 15.6356 3.36177 15.8031 3.54592 15.8031H13.4621C13.6463 15.8031 13.808 15.6363 13.8225 15.4338L14.5876 3.36257C14.6021 3.16756 14.779 3.0282 14.9776 3.03507C15.1836 3.04882 15.338 3.20944 15.3235 3.40444L14.5585 15.4756C14.5143 16.0538 14.0364 16.4994 13.4622 16.4994Z" fill="#1A2E25"/><path d="M5.70735 13.9436C5.51594 13.9436 5.35423 13.7973 5.33969 13.6161L4.85455 5.31289C4.83936 5.12476 4.99382 4.95788 5.19977 4.95101C5.39845 4.93039 5.57469 5.09039 5.58986 5.27852L6.08294 13.5817C6.09746 13.7767 5.93575 13.9367 5.73706 13.9511C5.72254 13.9436 5.71527 13.9436 5.70735 13.9436Z" fill="#1A2E25"/><path d="M11.2924 13.9433H11.2707C11.0647 13.9296 10.9103 13.769 10.9248 13.574L11.4178 5.27077C11.4324 5.07577 11.602 4.92265 11.8079 4.94327C12.0139 4.95702 12.1683 5.11764 12.1538 5.31265L11.6608 13.6158C11.6449 13.804 11.4832 13.9433 11.2924 13.9433Z" fill="#1A2E25"/><path d="M8.50309 13.9437C8.29714 13.9437 8.13543 13.7906 8.13543 13.5956L8.13477 5.2993C8.13477 5.10429 8.29648 4.95117 8.50243 4.95117C8.70837 4.95117 8.87008 5.1043 8.87008 5.2993L8.87074 13.5956C8.87074 13.7906 8.70111 13.9437 8.50309 13.9437Z" fill="#1A2E25"/></svg>
                    <p>Remove</p>
                  </button>
                </div>
              </div>
            )
          } else {
            return <></>
          }
        }
      })
      setSowItemTableHtml(html);
    }
    generateSowItemTableHtml()
    }, [combinedPaySowArray, isModalOpen]);

    const addToPaymentArray = (curretPayType: "milestone" | "final") => {
      // setFinalTotal(finalTotal + currentTotal);
      const newPayment: Payment = {
        itemDate: paymentDate,
        paymentType: curretPayType,
        coInvestDate: coInvestDate,
        // paymentAmount: curretPayType === "milestone" ? currentTotal : finalTotal,
        itemId: uuidv4()
      }
      // setCurrentTotal(0)
      const newArray = [...paymentArray, newPayment];
      // setPostMileStoneDate(newArray[newArray.length - 1].itemDate)
      setDeliverableDateMin(paymentDate)
      setDeliveryDate(paymentDate)
      setIsAddingMilestone(false)
      setIsAddingFinal(false)      
      setPaymentArray(newArray)
    }
  
  const updateCurrentTotal = (num: number) => {
    setCurrentTotal(currentTotal + num)
  }

  const updateCurrentTax = (num: number) => {
    setCurrentTax(currentTax + num)
  }

  const addToItemsArray = () => {
    if (itemDescription && amount && tax) {
    const expenseId = uuidv4()
    const newExpense = { itemDescription, amount, tax, hourlyRate, isLumpsum, effort, expenseId };
    const costBreakdown = ([...expenses, newExpense]);
    const costBreakdownTotal = costBreakdown.reduce((total, item) => total + parseFloat(item.amount), 0);
    const costBreakdownTotalTax = costBreakdown.reduce((total, item) => {
      if (item.tax) {
        return total + (parseFloat(item.amount) * parseFloat(item.tax))
      } 
      return total;
    }, 0)
    // updateCurrentTotal((costBreakdownTotal + costBreakdownTotalTax))
    const newSowItem: SowItem = {
      category: category,
      task: task,
      taskDescription: taskDescription,
      deliverable: deliverable,
      itemDate: deliveryDate,
      costBreakdown: costBreakdown,
      costBreakdownTotal: costBreakdownTotal,
      costBreakdownTotalTax: costBreakdownTotalTax,
      itemId: uuidv4()
    }
    const newArray = [...sowItemArray, newSowItem];
    setMilestonePayDateMin(deliveryDate)
    setPaymentDate(deliveryDate)
    // setCoInvestDateMax(newArray[0].itemDate)
    setFinalPayDateMin(deliveryDate),
    setSowItemArray(newArray)
    setExpenses([])
    setTax("")
    setAmount("")
    setItemDescription("")
    setAddingItem(false)
    setCategory("");
    setTaskDescription('');
    setTask('');
    setDeliverable("");
    setHourlyRate('')
    setIsLumpsum(false)
    setHourlyRate('')
    setEffort('');
  } else {
    alert("Please fill out all fields")
  }
  }

  // const saveSowButton = () => {
  //   alert("Thanks! End of testing process for now!")
  //   navigate("/dashboard/sow-requests")
  // }

  const handleAddExpense = () => {
    if (itemDescription && amount && tax) {
      const expenseId = uuidv4()
      const newExpense = { itemDescription, amount, tax, hourlyRate, isLumpsum, effort, expenseId };
      setExpenses([...expenses, newExpense]);
      setItemDescription('');
      setHourlyRate('')
      setAmount('');
      setTax('');
      setEffort('');
      setIsLumpsum(false);
    } else {
      alert('Please fill out all fields for current Cost Item before adding addtional');
    }
  };

  const handleItemDescriptionChange = (event: { target: { value: SetStateAction<string>; }; }) => {
    setItemDescription(event.target.value);
  };

  const handleItemHourlyChange = (event: { target: { value: SetStateAction<string>; }; }) => {
    const hourly = event.target.value as string
    setHourlyRate(event.target.value);
    if (effort) {
      handleAutomatedAmountChange(effort, hourly)
    }
  };

  const handleLumpsumChange = (event: { target: { checked: any; }; }) => {
    setIsLumpsum(event.target.checked); // Update state based on checkbox value
    setEffort("")
    setAmount("")
  };

  const handleAutomatedAmountChange = (hours: string, hourly: string) => {
    const itemAmount = (parseFloat(hours) * (parseFloat(hourly)))
    setAmount(itemAmount.toString());
  };

  const handleAmountChange = (event: { target: { value: SetStateAction<string>; }; }) => {
    setAmount(event.target.value);
  };

  const handleTaxChange = (event: { target: { value: SetStateAction<string>; }; }) => {
    setTax(event.target.value);
  };

  const handleCategoryChange = (event: { target: { value: SetStateAction<string>; }; }) => {
    setCategory(event.target.value);
  };

  const handleTaskChange = (event: { target: { value: SetStateAction<string>; }; }) => {
    setTask(event.target.value);
  };

  const handleTaskDescriptionChange = (event: { target: { value: SetStateAction<string>; }; }) => {
    setTaskDescription(event.target.value);
  };
  
  const handleDeliverableChange = (event: { target: { value: SetStateAction<string>; }; }) => {
    setDeliverable(event.target.value);
  };

  const handleEffortChange = (event: { target: { value: SetStateAction<string>; }; }) => {
    const hours = event.target.value as string
    setEffort(event.target.value);
    if (hourlyRate) {
      handleAutomatedAmountChange(hours, hourlyRate)
    }
  };

  const handleDateChange = (date: Date | null) => {
    if (date) {
      setDeliveryDate(date);
    }
  };

  const handlePaymentDateChange = (date: Date | null) => {
    if (date) {
      setPaymentDate(date);
    }
  };

  const handleCoPaymentDateChange = (date: Date | null) => {
    if (date) {
      setCoPaymentDate(date);
    }
  };

  async function saveSowButton() {
    console.log(combinedPaySowArray)
    let saveSowItemsArray = [] as SowItem[]
    let savePayItemsArray = [] as Payment[]
    combinedPaySowArray.forEach(obj => {
      if (obj.hasOwnProperty('category')) {
        saveSowItemsArray.push(obj as SowItem);
      }
      if (obj.hasOwnProperty('paymentType')) {
        savePayItemsArray.push(obj as Payment);
      }
  });
    const sowDetailsToSave = {
      title: title,
      sowId: sowDetails.sowId,
      description: description,
      sowItemArray: saveSowItemsArray,
      paymentArray: savePayItemsArray,
      coInvestDate: coInvestDate,
      coInvestAmount: coInvestAmount
    } 
    showLoading();
    const response = await serviceProviderSaveProgressSow(sowDetailsToSave);
    hideLoading();

    if (response.success){
      handleFormSaveResponse(response, showToast, {message: "Statement of work saved!"});
    }
  }

  const openSowModal = () => {
    setIsModalOpen(true)
  }

  async function submitSow() {
    let saveSowItemsArray = [] as SowItem[]
    let savePayItemsArray = [] as Payment[]
    combinedPaySowArray.forEach(obj => {
      if (obj.hasOwnProperty('category')) {
        saveSowItemsArray.push(obj as SowItem);
      }
      if (obj.hasOwnProperty('paymentType')) {
        savePayItemsArray.push(obj as Payment);
      }
  });
    const sowDetailsToSubmit = {
      title: title,
      sowId: sowDetails.sowId,
      description: description,
      sowItemArray: saveSowItemsArray,
      paymentArray: savePayItemsArray,
      coInvestDate: coInvestDate,
      coInvestAmount: coInvestAmount,
      providerToStartUpDate: date
    } 
    showLoading();
    const response = await serviceProviderSubmitSow(sowDetailsToSubmit);
    hideLoading();

    if (response.success){
      navigate("/dashboard")
      handleFormSaveResponse(response, showToast, {message: "Statement of work saved!"});
    }
  }

  const editRequestItemDisabledBoolean = paymentArray.some(item => item.paymentType === 'final' && sowDetails.sowStatus === "Edit Request from Startup") ? true : paymentArray.some(item => item.paymentType === 'final' && sowDetails.sowStatus === "Edit Requested from Admin" ) ? true : false

  const handleDescriptionBlur = (event: { target: { value: SetStateAction<string>; }; }) => {
    setDescription(event.target.value);
  };

  const handleTitleChange = (event: { target: { value: SetStateAction<string>; }; }) => {
    setTitle(event.target.value);
  };

  return (
    <div className="flex flex-col">
      {viewingGuidelines && 
        <div className='largeModal'>
          <div className='largeModalInner !h-fit !w-fit'>
            <div className='flex justify-end w-full'>
              <button onClick={() => setViweingGuidelines(false)}>
                <svg xmlns="http://www.w3.org/2000/svg" width="10" height="10" viewBox="0 0 10 10" fill="none"><path d="M9 1L1 9M1 1L9 9" stroke="#1A2E25" stroke-linecap="round" stroke-linejoin="round"/></svg>
              </button>
            </div>  
            <PdfDownloader docKey="Template-EIP-SOW v6 - Guidelines"/>
          </div>  
        </div>  

      }
      <div className="flex justify-between mx-[56px] mb-8">
        <h1>{pageTitleString(sowDetails.sowStatus)}</h1>
        <div className="flex gap-8">
          {
            sowDetails.sowStatus === "Edit Request from Startup" &&
            <Button
            buttonText="View Startup Feedback"
            actionHandler={() => viewStartupFeedback()}
            buttonType="secondary"
          />
          }
          {
            sowDetails.sowStatus === "Edit Requested from Admin" &&
            <Button
            buttonText="View Admin Feedback"
            actionHandler={() => viewAdminFeedback()}
            buttonType="secondary"
          />
          }
          <Button
            buttonText="View Guidelines"
            actionHandler={() => setViweingGuidelines(true)}
            buttonType="secondary"
          />
          <Button
            buttonText="Save Progress"
            actionHandler={saveSowButton}
            disabled={!addingItem}
          />
          <Button
            buttonText="Submit"
            actionHandler={() => openSowModal()}
            disabled={!paymentArray.some(payment => payment.paymentType === "final")}
          />
        </div>
      </div>
      <div className="flex justify-between gap-6 mx-[56px] mb-8">
        <div className="flex flex-col w-1/2">
          <h3 className="font-semibold">ElevateIP</h3>
          <h3>Tier {`${sowDetails.tier}`} Scope of Work (SoW)</h3>
          <h3>and Attestation of Fund Usage</h3>
        </div>
        <div className="flex flex-col w-1/2 h-full justify-between">
          <div className="flex w-full">
            <p className="font-semibold sow-details-head-p">Service Provider Name:</p>
            <p>{sowDetails.firmName}</p>
          </div>
          <div className="flex w-full">
            <p className="font-semibold sow-details-head-p">Startup Name:</p>
            <p>{sowDetails.startupName}</p>
          </div>
          <div className="flex w-full">
            <p className="font-semibold sow-details-head-p">Date:</p>
            <p>{moment(date).format('MMM Do YYYY').toString()}</p>
          </div>
        </div>
      </div>
      <div className="flex justify-between gap-6 mx-[56px]">
        <div className="flex flex-col w-1/2 gap-2">
          <p className="bodyLarger font-semibold">Title</p>
          <input className={inputClasses} defaultValue={title} value={title} placeholder="Type title here..." type="text" onChange={handleTitleChange}></input>
          <p className="pl-4 bodySmaller text-cSecondaryGreen">Short and descriptive title</p>
        </div>
        <div className="flex flex-col w-1/2 gap-2">
          <p className="bodyLarger font-semibold">Description</p>
          <textarea className={`min-h-[112px] + ${inputClasses}`} defaultValue={description} placeholder="Type title here..." onBlur={handleDescriptionBlur}></textarea>
          <p className="pl-4 bodySmaller text-cSecondaryGreen">High-level description of the specific details of the service to be performed</p>
        </div>
      </div>
        <div className="flex flex-col">
          <div className="w-full flex flex-col overflow-y-auto mb-10">
            <div style={{ width: 'calc(100% - 112px)' }} className="my-[16px] mx-[56px] border-cSage border-t-[1px]">
              {sowItemArray.length !== 0 &&
                <div className="flex flex-col w-full mt-4">
                  <div className="w-full font-medium flex gap-2 bg-backgrounds text-text">
                    <div className="h-full " style={{ width: '15%', display: 'inline-block' }}>
                        <p className="flex grow font-semibold break-all text-text/80 self-center capitalize">Category</p>
                    </div>
                    <div className="h-full " style={{ width: '24%', display: 'inline-block' }}>
                        <p className="flex grow font-semibold break-all text-text/80 self-center capitalize">Task Description</p>
                    </div>
                    <div className="h-full " style={{ width: '24%', display: 'inline-block' }}>
                        <p className="flex grow font-semibold break-all text-text/80 self-center capitalize">Deliverable</p>
                    </div>
                    {/* <div className="h-full " style={{ width: '12%', display: 'inline-block' }}>
                        <p className="flex grow font-semibold break-all text-text/80 self-center capitalize">Effort (hours)</p>
                    </div> */}
                    <div className="h-full " style={{ width: '12%', display: 'inline-block' }}>
                        <p className="flex grow font-semibold break-all text-text/80 self-center capitalize">Date</p>
                    </div>
                    <div className="h-full " style={{ width: '24%', display: 'inline-block' }}>
                        <p className="flex grow font-semibold break-all text-text/80 self-center capitalize">Cost Breakdown ($ CAD)</p>
                    </div>
                  </div>
                </div>
              } 
            </div>
            <div style={{ width: 'calc(100% - 112px)' }} className="mx-[56px] flex flex-col">
            {sowItemTableHtml}
            </div>
            {
              addingItem && !isEditing &&
              <div id="AddingItemCont" style={{ width: 'calc(100% - 64px)' }} className="mx-[32px] sowAddingCont">
                <div className="flex flex-col w-full mb-2">
                  <div className="w-full flex gap-2">
                    <div className="h-full " style={{ width: '15%', display: 'inline-block' }}>
                      <p className="flex grow  font-semibold break-all text-text/80 self-center capitalize">Category</p>
                    </div>
                    <div className="h-full " style={{ width: '24%', display: 'inline-block' }}>
                      <p className="flex grow  font-semibold break-all text-text/80 self-center capitalize">Task Description</p>
                    </div>
                    <div className="h-full " style={{ width: '24%', display: 'inline-block' }}>
                      <p className="flex grow  font-semibold break-all text-text/80 self-center capitalize">Deliverable</p>
                    </div>
                    {/* <div className="h-full " style={{ width: '12%', display: 'inline-block' }}>
                      <p className="flex grow  font-semibold break-all text-text/80 self-center capitalize">Effort (hours)</p>
                    </div> */}
                    <div className="h-full " style={{ width: '12%', display: 'inline-block' }}>
                      <p className="flex grow font-semibold break-all text-text/80 self-center capitalize">Date</p>
                    </div>
                    <div className="h-full " style={{ width: '24%', display: 'inline-block' }}>
                      <p className="flex grow font-semibold break-all text-text/80 self-center capitalize">Cost Breakdown ($ CAD)</p>
                    </div>
                  </div>
                </div>
                <div className="w-full flex gap-2">
                  <div className="h-full " style={{ width: '15%', display: 'inline-block', font: '12px !important'}}>
                    <label className="[&>a]:underline [&>a]:text-text/70 [&>a]:hover:text-text hidden sr-only" htmlFor="category">Category:</label>
                      {
                        isTier2 ? 
                        <select className={`${inputClasses} flex grow break-word self-center max-w-full overflow-hidden whitespace-normal`} id="category" name="category" style={{wordWrap: "break-word"}} onChange={handleCategoryChange}>
                          <option className="!text-cSecondaryGreen" selected={true} disabled>Select a Category</option>
                          <option value="Strategy">Strategy</option>
                          <option value="Patent">Patent</option>
                          <option value="Trademark">Trademark</option>
                          <option value="Trade Secret">Trade Secret</option>
                          <option value="Other">Other</option>
                        </select>
                        :
                        <select className={`${inputClasses} flex grow break-word self-center max-w-full overflow-hidden whitespace-normal`} id="category" name="category" style={{wordWrap: "break-word"}} onChange={handleCategoryChange}>
                          <option className="!text-cSecondaryGreen" selected={true} disabled>Select a Category</option>
                          <option value="Patent Filing">Patent Filing</option>
                          <option value="Patent Conversion">Patent Conversion</option>
                          <option value="Patent Prosecution">Patent Prosecution</option>
                          <option value="Design Patent/Industrial Design">Design Patent/Industrial Design</option>
                          <option value="Agreements">Agreements</option>
                          <option value="Other">Other</option> 
                        </select>
                      }
                    <div className="flex flex-col mt-2">
                      <label className="[&>a]:underline [&>a]:text-text/70 [&>a]:hover:text-text font-semibold mb-2" htmlFor="task">Task</label>
                      {
                        category === "" &&
                        <select className={`${inputClasses} flex grow break-word self-center max-w-full overflow-hidden whitespace-normal`} disabled={category === ""} id="task" name="task" style={{wordWrap: "break-word"}} onChange={handleTaskChange}>
                          <option className="!text-cSecondaryGreen" selected={true} disabled>Select Category First</option>

                        </select>
                      }
                      {
                        isTier2 && category === "Strategy" &&
                        <select className={`${inputClasses} flex grow break-word self-center max-w-full overflow-hidden whitespace-normal`} id="task" name="task" style={{wordWrap: "break-word"}} onChange={handleTaskChange}>
                          <option className="!text-cSecondaryGreen" selected={true} disabled>Select a Task</option>
                          <option value="General IP Strategy Development">General IP Strategy Development</option>
                          <option value="Patent Strategy Session">Patent Strategy Session</option>
                          <option value="Trademark/Branding Strategy Session">Trademark/Branding Strategy Session</option>
                          <option value="IP Licensing Strategy Session">IP Licensing Strategy Session</option>
                          <option value="Other">Other</option> 
                        </select>
                      }
                      {
                        isTier2 && category === "Patent" &&
                        <select className={`${inputClasses} flex grow break-word self-center max-w-full overflow-hidden whitespace-normal`} id="task" name="task" style={{wordWrap: "break-word"}} onChange={handleTaskChange}>
                          <option className="!text-cSecondaryGreen" selected={true} disabled>Select a Task</option>
                          <option value="Invention Mining/Patent Mining Session and Report">Invention Mining/Patent Mining Session and Report</option>
                          <option value="Patentability/Novelty/Prior Art Search">Patentability/Novelty/Prior Art Search</option>
                          <option value="Patent Landscape Report">Patent Landscape Report</option>
                          <option value="Other">Other</option> 
                        </select>
                      }
                      {
                        isTier2 && category === "Trademark" &&
                        <select className={`${inputClasses} flex grow break-word self-center max-w-full overflow-hidden whitespace-normal`} id="task" name="task" style={{wordWrap: "break-word"}} onChange={handleTaskChange}>
                          <option className="!text-cSecondaryGreen" selected={true} disabled>Select a Task</option>
                          <option value="Trademark Clearance Search - Canada">Trademark Clearance Search - Canada</option>
                          <option value="Trademark Clearance Search - US">Trademark Clearance Search - US</option>
                          <option value="Trademark Clearance Search - EU">Trademark Clearance Search - EU</option>
                          <option value="Trademark Clearance Search - Other jurisdiction">Trademark Clearance Search - Other jurisdiction</option>
                          <option value="Other">Other</option>
                        </select>
                      }
                      {
                        isTier2 && category === "Agreements" &&
                        <select className={`${inputClasses} flex grow break-word self-center max-w-full overflow-hidden whitespace-normal`} id="task" name="task" style={{wordWrap: "break-word"}} onChange={handleTaskChange}>
                          <option className="!text-cSecondaryGreen" selected={true} disabled>Select a Task</option>
                          <option value="Review of IP clauses/IP ownership">Review of IP clauses/IP ownership</option>
                          <option value="Drafting for IP clauses/IP ownership">Drafting for IP clauses/IP ownership</option>
                          <option value="Other">Other</option> 
                        </select>
                      }
                      {
                        isTier2 && category === "Trade Secret" &&
                        <select className={`${inputClasses} flex grow break-word self-center max-w-full overflow-hidden whitespace-normal`} id="task" name="task" style={{wordWrap: "break-word"}} onChange={handleTaskChange}>
                          <option className="!text-cSecondaryGreen" selected={true} disabled>Select a Task</option>
                          <option value="Trade Secret Protection Plan">Trade Secret Protection Plan</option>
                          <option value="Other">Other</option> 
                        </select>
                      }
                      {
                        isTier2 && category === "Other" &&
                        <select className={`${inputClasses} flex grow break-word self-center max-w-full overflow-hidden whitespace-normal`} id="task" name="task" style={{wordWrap: "break-word"}} onChange={handleTaskChange}>
                          <option className="!text-cSecondaryGreen" selected={true} disabled>Select a Task</option>
                          <option value="Other">Other</option> 
                        </select>
                      }
                      {
                        !isTier2 && category === "Patent Filing" &&
                        <select className={`${inputClasses} flex grow break-word self-center max-w-full overflow-hidden whitespace-normal`} id="task" name="task" style={{wordWrap: "break-word"}} onChange={handleTaskChange}>
                          <option className="!text-cSecondaryGreen" selected={true} disabled>Select a Task</option>
                          <option value="Patent Filing, including initial drafting - Canada">Patent Filing, including initial drafting - Canada</option>
                          <option value="Patent Filing, regular application, including initial drafting - US">Patent Filing, regular application, including initial drafting - US</option>
                          <option value="Patent Filing, including drafting - EP (EU)">Patent Filing, including drafting - EP (EU)</option>
                          <option value="Patent Filing - PCT">Patent Filing - PCT</option>
                          <option value="Patent Filing, provisional application - US">Patent Filing, provisional application - US</option>
                          <option value="Other">Other</option>
                        </select>
                      }
                      {
                        !isTier2 && category === "Patent Conversion" &&
                        <select className={`${inputClasses} flex grow break-word self-center max-w-full overflow-hidden whitespace-normal`} id="task" name="task" style={{wordWrap: "break-word"}} onChange={handleTaskChange}>
                          <option className="!text-cSecondaryGreen" selected={true} disabled>Select a Task</option>
                          <option value="Converting PCT to CA national filing">Converting PCT to CA national filing</option>
                          <option value="Convert PCT to US national filing">Convert PCT to US national filing</option>
                          <option value="Converting US provisional to regular US application">Converting US provisional to regular US application</option>
                          <option value="Converting US provisional to PCT">Converting US provisional to PCT</option>
                          <option value="Converting US provisional to other national filing">Converting US provisional to other national filing</option>
                          <option value="Other">Other</option>
                        </select>
                      }
                      {
                        !isTier2 && category === "Patent Prosecution" &&
                        <select className={`${inputClasses} flex grow break-word self-center max-w-full overflow-hidden whitespace-normal`} id="task" name="task" style={{wordWrap: "break-word"}} onChange={handleTaskChange}>
                          <option className="!text-cSecondaryGreen" selected={true} disabled>Select a Task</option>
                          <option value="Patent Prosecution - Responding to Office Action">Patent Prosecution - Responding to Office Action</option>
                          <option value="Paying Notice of Allowance for Patent - CA">Paying Notice of Allowance for Patent - CA</option>
                          <option value="Paying Notice of Allowance for Patent - US">Paying Notice of Allowance for Patent - US</option>
                          <option value="Paying Notice of Allowance for Patent - EP (EU)">Paying Notice of Allowance for Patent - EP (EU)</option>
                          <option value="Paying Notice of Allowance for Patent - Other jurisdiction">Paying Notice of Allowance for Patent - Other jurisdiction</option>
                          <option value="Other">Other</option>
                        </select>
                      }
                      {
                        !isTier2 && category === "Trademark" &&
                        <select className={`${inputClasses} flex grow break-word self-center max-w-full overflow-hidden whitespace-normal`} id="task" name="task" style={{wordWrap: "break-word"}} onChange={handleTaskChange}>
                          <option className="!text-cSecondaryGreen" selected={true} disabled>Select a Task</option>
                          <option value="Trademark Filing - Canada">Trademark Filing - Canada</option>
                          <option value="Trademark Filing - US">Trademark Filing - US</option>
                          <option value="Trademark Filing - Other jurisdiction">Trademark Filing - Other jurisdiction</option>
                          <option value="Other">Other</option>
                        </select>
                      }
                      {
                        !isTier2 && category === "Agreements" &&
                        <select className={`${inputClasses} flex grow break-word self-center max-w-full overflow-hidden whitespace-normal`} id="task" name="task" style={{wordWrap: "break-word"}} onChange={handleTaskChange}>
                          <option className="!text-cSecondaryGreen" selected={true} disabled>Select a Task</option>
                          <option value="Review and/or drafting Licensing agreement">Review and/or drafting Licensing agreement</option>
                          <option value="Other">Other</option>
                        </select>
                      }
                      {
                        !isTier2 && category === "Design Patent/Industrial Design" &&
                        <select className={`${inputClasses} flex grow break-word self-center max-w-full overflow-hidden whitespace-normal`} id="task" name="task" style={{wordWrap: "break-word"}} onChange={handleTaskChange}>
                          <option className="!text-cSecondaryGreen" selected={true} disabled>Select a Task</option>
                          <option value="Design Patent/Industrial Design Application - US">Design Patent/Industrial Design Application - US</option>
                          <option value="Design Patent/Industrial Design Application - Other jurisdiction">Design Patent/Industrial Design Application - Other jurisdiction</option>
                          <option value="Other">Other</option>
                        </select>
                      }
                      {
                        !isTier2 && category === "Other" &&
                        <select className={`${inputClasses} flex grow break-word self-center max-w-full overflow-hidden whitespace-normal`} id="task" name="task" style={{wordWrap: "break-word"}} onChange={handleTaskChange}>
                          <option className="!text-cSecondaryGreen" selected={true} disabled>Select a Task</option>
                          <option value="Open Source Review and Inventory">Open Source Review and Inventory</option>
                          <option value="Other">Other</option>
                        </select>
                      }
                    </div>
                  </div>
                  <div className="!h-full !min-h-full" style={{ width: '24%', display: 'inline-block' }}>
                    <label className="font-semibold [&>a]:underline [&>a]:text-text/70 [&>a]:hover:text-text hidden" htmlFor="taskDescription">Description:</label>
                    <textarea wrap="soft" className={`${inputClasses} !bodySmaller !h-full !min-h-full`} id="taskDescription" placeholder="Task description" onChange={handleTaskDescriptionChange}></textarea>
                  </div>
                  <div className="h-full " style={{ width: '24%', display: 'inline-block' }}>
                    <label className="font-semibold [&>a]:underline [&>a]:text-text/70 [&>a]:hover:text-text hidden" htmlFor="deliverable">Deliverable:</label>
                    <textarea wrap="soft" className={`${inputClasses} !h-full !min-h-full`} id="deliverable" placeholder="Task deliverables" onChange={handleDeliverableChange} />
                  </div>
                  {/* <div className="h-full " style={{ width: '12%', display: 'inline-block' }}>
                    {!isLumpsum &&
                    <div>
                      <label className="font-semibold [&>a]:underline [&>a]:text-text/70 [&>a]:hover:text-text hidden" htmlFor="effort">Effort:</label>
                      <input className="bg-background border-none w-full flex" type="number" id="effort" placeholder="###" onChange={handleEffortChange} />
                    </div>
                    }
                    <div className="flex gap-2 items-center">
                    <label className="bodySmaller flex gap-2 items-center mt-2">
                      <input 
                        type="checkbox" 
                        checked={isLumpsum}
                        onChange={handleLumpsumChange}
                      />
                      Payment is a one time fee?
                    </label>
                    </div>
                  </div> */}
                  <div className="h-full " style={{ width: '12%', display: 'inline-block' }}>
                    <DatePicker 
                      className={" w-full text-text bg-background !border-cSecondaryGreen input"}
                      selected={deliverableDateMin > deliveryDate ? deliverableDateMin : deliveryDate}
                      id={"Deliverable Date"}
                      scrollableYearDropdown={true}
                      showYearDropdown
                      yearDropdownItemNumber={115}
                      onChange={handleDateChange}
                      minDate={new Date(deliverableDateMin)}
                      maxDate={finalPaymentDate ? new Date(finalPaymentDate) : null}
                    />
                  </div>
                  <div className="h-full" style={{ width: '24%', display: 'inline-block' }}>
                    <form>
                      <div className="flex flex-col">
                        <label aria-label="Cost Description" className="mb-2 [&>a]:underline [&>a]:text-text/70 [&>a]:hover:text-text" htmlFor="itemDescription">Description:</label>
                        <input className={`${inputClasses}`} type="text" placeholder="Cost description" id="itemDescription" value={itemDescription} onChange={handleItemDescriptionChange} />
                      </div>
                      <div className="flex flex-col">
                    {!isLumpsum &&
                    <div className="mt-2 flex flex-col">
                      <label className="mb-2" htmlFor="effort">Effort (Hours):</label>
                      <input className={`${inputClasses}`} type="number" id="effort" placeholder="###" value={effort} onChange={handleEffortChange} />
                    </div>
                    }
                    <div className="flex gap-2 items-center">
                    <label className="bodySmaller flex gap-2 items-center mt-2">
                      <input 
                        type="checkbox" 
                        checked={isLumpsum}
                        onChange={handleLumpsumChange}
                      />
                      Payment is a fixed rate
                    </label>
                    </div>
                  </div>
                      {!isLumpsum &&
                      <div className="flex flex-col mt-2">
                        <label className="[&>a]:underline [&>a]:text-text/70 [&>a]:hover:text-text mb-2" htmlFor="amount">Hourly Rate:</label>
                        <input className={`${inputClasses}`} type="number" placeholder="Hourly Rate"  id="amount" value={hourlyRate} onChange={handleItemHourlyChange} />
                      </div>
                      }
                      <div className="flex flex-col mt-2">
                        <label className="[&>a]:underline [&>a]:text-text/70 [&>a]:hover:text-text mb-2" htmlFor="amount">Amount (Pre-Tax):</label>
                        <input className={`${inputClasses}`} type="number" placeholder="Amount" disabled={!isLumpsum} id="amount" value={amount} onChange={handleAmountChange} />
                      </div>
                      <div className="flex flex-col mt-2">
                        <label className="&>a]:underline [&>a]:text-text/70 [&>a]:hover:text-text mb-2" htmlFor="tax">Tax:</label>
                        <select className={`${inputClasses}`} placeholder="Amount (pre-tax)" id="tax" value={tax} onChange={handleTaxChange}>
                        <option value="" disabled>Select a Tax Rate</option>
                          <option value="0">0%</option>
                          <option value="0.05">5%</option>
                          <option value="0.13">13%</option>
                        </select>
                      </div>
                      <div className="flex">
                        <button 
                          className="flex gap-2 w-full items-center mt-2" type="button" onClick={handleAddExpense}>
                          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"><path d="M12 24C5.38247 24 0 18.6173 0 12C0 5.38274 5.38274 0 12 0C18.6173 0 24 5.38274 24 12C24 18.6173 18.6173 24 12 24ZM12 1.34831C6.1262 1.34831 1.34831 6.12642 1.34831 12C1.34831 17.8736 6.12642 22.6517 12 22.6517C17.8736 22.6517 22.6517 17.8736 22.6517 12C22.6517 6.12642 17.8736 1.34831 12 1.34831Z" fill="#1A2E25"/><path d="M12.0003 17.3279C11.6274 17.3279 11.3262 17.0266 11.3262 16.6537V7.34603C11.3262 6.97314 11.6274 6.67188 12.0003 6.67188C12.3732 6.67188 12.6745 6.97314 12.6745 7.34603V16.6602C12.6745 17.0268 12.3732 17.3279 12.0003 17.3279Z" fill="#1A2E25"/><path d="M16.6537 12.6745H7.34603C6.97314 12.6745 6.67188 12.3732 6.67188 12.0003C6.67188 11.6274 6.97314 11.3262 7.34603 11.3262H16.6602C17.0331 11.3262 17.3343 11.6274 17.3343 12.0003C17.3343 12.3732 17.0266 12.6745 16.6537 12.6745Z" fill="#1A2E25"/></svg>  
                          <p className="underline bodyLarger">Add Another Cost Item</p>
                        </button> 
                      </div>
                    </form>
                    {expenses.length > 0 &&
                    <ul className="bg-cBlue w-full">
                      {expenses.map((expense, index) => (
                        <li key={index} className={index === 0 ? `expenseLi w-full` : "expenseLi border-top-[1px] border-cSage"}>
                        <div className="w-full">
                          {expense.itemDescription}
                        </div> 
                        {
                          !expense.isLumpsum &&
                          <div className="flex w-full bodySmaller">
                            <span className="w-1/3">Hours: {expense.effort}</span>
                            <span className="w-2/3">Hourly Rate: ${expense.hourlyRate}</span>
                          </div>                           
                        }
                        <div className="flex w-full bodySmaller">
                          <span className="w-1/3">$ {expense.amount}</span>
                          <span className="w-2/3">{expense.tax === "0" ? "No Tax" : expense.tax === "0.05" ? `5% tax =  $ ${((parseFloat(expense.amount) * (parseFloat(expense.tax))) + parseFloat(expense.amount)).toFixed(2)}` : `13% tax =  $ ${((parseFloat(expense.amount) * (parseFloat(expense.tax))) + parseFloat(expense.amount)).toFixed(2)}`}  </span>
                        </div>
                        </li>
                      ))}
                    </ul>
                    }
                  </div>
                </div>
              </div>
            }
            {
              isAddingMilestone &&
              <div id="MilestoneItemCont" style={{ width: 'calc(100% - 64px)' }} className="mx-[32px] sowAddingCont !flex-row gap-2 items-center!">
                <div className="flex items-center" style={{ width: '64%', display: 'inline-flex' }}>
                  <p className="font-semibold">Progress Milestone Payment</p>
                </div>
                  <div className=" " style={{ width: '12%', display: 'inline-block' }}>
                    <DatePicker 
                      className={inputClasses}
                      selected={paymentDate}
                      id={"MilestonePaymentDate"}
                      scrollableYearDropdown={true}
                      showYearDropdown
                      yearDropdownItemNumber={115}
                      onChange={handlePaymentDateChange}
                      minDate={milestonePayDateMin}
                    />   
                  </div>
                <div className="flex items-center"  style={{ width: '21%', display: 'inline-flex' }}>
                  {/* <p className=""><span className="fonr-semibold">Amount:</span> ${currentTotal.toFixed(2)}</p> */}
                </div>
              </div>
            }
            {
              isTier2 && isAddingFinal &&
              <div id="FinalAddingItemCont" style={{ width: 'calc(100% - 64px)' }} className="mx-[32px] sowAddingCont !flex-row gap-2 items-center!">
                <div className="h-full items-center" style={{ width: '64%', display: 'inline-flex' }}>
                  <p className="flex grow break-word font-normal text-text/80 self-center capitalize">Final Payment Date</p>
                </div>
                  <div className="h-full " style={{ width: '12%', display: 'inline-flex' }}>               
                    <DatePicker 
                      title={"Final Payment Date"}
                      className={inputClasses}
                      selected={finalPayDateMin > paymentDate ? finalPayDateMin : paymentDate}
                      id={"FinalPaymentDate"}
                      scrollableYearDropdown={true}
                      showYearDropdown
                      yearDropdownItemNumber={115}
                      onChange={handlePaymentDateChange}
                      minDate={sowItemArray[sowItemArray.length - 1].itemDate}
                    />
                  </div>
              </div>
            }
            {
              !isTier2 && isAddingFinal &&
              <div id="FinalAddingItemCont" style={{ width: 'calc(100% - 64px)' }} className="mx-[32px] sowAddingCont gap-2 !items-center">
                <div className="w-full">
                  <div className=" " style={{ width: '64%', display: 'inline-flex' }}>
                    <p className="font-semibold">Final Payment Date</p>
                  </div>
                  <div className="" style={{ width: '12%', display: 'inline-flex' }}>               
                      <DatePicker 
                        title={"Final Payment Date"}
                        className={inputClasses}
                        selected={finalPayDateMin > paymentDate ? finalPayDateMin : paymentDate}
                        id={"FinalPaymentDate"}
                        scrollableYearDropdown={true}
                        showYearDropdown
                        yearDropdownItemNumber={115}
                        onChange={handlePaymentDateChange}
                        minDate={sowItemArray[sowItemArray.length - 1].itemDate}
                      />
                    </div>
                  </div>
                  <div className="w-full mt-4">
                    <div className="items-center" style={{ width: '64%', display: 'inline-flex' }}>
                      <p className="font-semibold">Co-Invest Payment Date</p>
                    </div>
                    <div className="" style={{ width: '12%', display: 'inline-flex' }}>
                      <DatePicker 
                        title={"Co-Investment Payment Date"}
                        className={inputClasses}
                        selected={coPaymentDate}
                        id={"CoInvestPaymentDate"}
                        scrollableYearDropdown={true}
                        showYearDropdown
                        yearDropdownItemNumber={115}
                        onChange={handleCoPaymentDateChange}
                        maxDate={sowItemArray[0].itemDate}
                      />
                    </div>
                  </div>
              </div>
            }
            {
              isEditing && editingItem.hasOwnProperty('category') &&
              <div id="EditItemCont" style={{ width: 'calc(100% - 64px)' }} className="mx-[32px] sowAddingCont">
                <div className="flex flex-col w-full mb-2">
                  <div className="w-full flex gap-2">
                    <div className="h-full " style={{ width: '15%', display: 'inline-block' }}>
                      <p className="flex grow  font-semibold break-all text-text/80 self-center capitalize">Category</p>
                    </div>
                    <div className="h-full " style={{ width: '24%', display: 'inline-block' }}>
                      <p className="flex grow  font-semibold break-all text-text/80 self-center capitalize">Task Description</p>
                    </div>
                    <div className="h-full " style={{ width: '24%', display: 'inline-block' }}>
                      <p className="flex grow  font-semibold break-all text-text/80 self-center capitalize">Deliverable</p>
                    </div>
                    {/* <div className="h-full " style={{ width: '12%', display: 'inline-block' }}>
                      <p className="flex grow  font-semibold break-all text-text/80 self-center capitalize">Effort (hours)</p>
                    </div> */}
                    <div className="h-full " style={{ width: '12%', display: 'inline-block' }}>
                      <p className="flex grow font-semibold break-all text-text/80 self-center capitalize">Date</p>
                    </div>
                    <div className="h-full " style={{ width: '24%', display: 'inline-block' }}>
                      <p className="flex grow font-semibold break-all text-text/80 self-center capitalize">Cost Breakdown ($ CAD)</p>
                    </div>
                  </div>
                </div>
                <div className="w-full flex gap-2">
                  <div className="h-full " style={{ width: '15%', display: 'inline-block', font: '12px !important'}}>
                    <label className="[&>a]:underline [&>a]:text-text/70 [&>a]:hover:text-text hidden sr-only" htmlFor="category">Category:</label>
                      {
                        isTier2 ? 
                        <select className={`${inputClasses} flex grow break-word self-center max-w-full overflow-hidden whitespace-normal`} value={category} id="category" name="category" style={{wordWrap: "break-word"}} onChange={handleCategoryChange}>
                          <option className="!text-cSecondaryGreen" selected={true} disabled>Select a Category</option>
                          <option value="Strategy">Strategy</option>
                          <option value="Patent">Patent</option>
                          <option value="Trademark">Trademark</option>
                          <option value="Trade Secret">Trade Secret</option>
                          <option value="Other">Other</option>
                        </select>
                        :
                        <select className={`${inputClasses} flex grow break-word self-center max-w-full overflow-hidden whitespace-normal`} value={category} id="category" name="category" style={{wordWrap: "break-word"}} onChange={handleCategoryChange}>
                          <option className="!text-cSecondaryGreen" selected={true} disabled>Select a Category</option>
                          <option value="Patent Filing">Patent Filing</option>
                          <option value="Patent Conversion">Patent Conversion</option>
                          <option value="Patent Prosecution">Patent Prosecution</option>
                          <option value="Design Patent/Industrial Design">Design Patent/Industrial Design</option>
                          <option value="Agreements">Agreements</option>
                          <option value="Other">Other</option> 
                        </select>
                      }
                    <div className="flex flex-col mt-2">
                      <label className="[&>a]:underline [&>a]:text-text/70 [&>a]:hover:text-text font-semibold mb-2" htmlFor="task">Task</label>
                      {
                        category === "" &&
                        <select className={`${inputClasses} flex grow break-word self-center max-w-full overflow-hidden whitespace-normal`} disabled={category === ""} id="task" name="task" style={{wordWrap: "break-word"}} onChange={handleTaskChange}>
                          <option className="!text-cSecondaryGreen" selected={true} disabled>Select Category First</option>

                        </select>
                      }
                      {
                        isTier2 && category === "Strategy" &&
                        <select className={`${inputClasses} flex grow break-word self-center max-w-full overflow-hidden whitespace-normal`} id="task" value={task} name="task" style={{wordWrap: "break-word"}} onChange={handleTaskChange}>
                          <option className="!text-cSecondaryGreen" selected={true} disabled>Select a Task</option>
                          <option value="General IP Strategy Development">General IP Strategy Development</option>
                          <option value="Trademark/Branding Strategy Session">Trademark/Branding Strategy Session</option>
                          <option value="IP Licensing Strategy Session">IP Licensing Strategy Session</option>
                          <option value="Other">Other</option> 
                        </select>
                      }
                      {
                        isTier2 && category === "Patent" &&
                        <select className={`${inputClasses} flex grow break-word self-center max-w-full overflow-hidden whitespace-normal`} id="task" value={task} name="task" style={{wordWrap: "break-word"}} onChange={handleTaskChange}>
                          <option className="!text-cSecondaryGreen" selected={true} disabled>Select a Task</option>
                          <option value="Invention Mining/Patent Mining Session and Report">Invention Mining/Patent Mining Session and Report</option>
                          <option value="Patentability/Novelty/Prior Art Search">Patentability/Novelty/Prior Art Search</option>
                          <option value="Patent Landscape Report">Patent Landscape Report</option>
                          <option value="Other">Other</option> 
                        </select>
                      }
                      {
                        isTier2 && category === "Trademark" &&
                        <select className={`${inputClasses} flex grow break-word self-center max-w-full overflow-hidden whitespace-normal`} id="task" value={task} name="task" style={{wordWrap: "break-word"}} onChange={handleTaskChange}>
                          <option className="!text-cSecondaryGreen" selected={true} disabled>Select a Task</option>
                          <option value="Trademark Clearance Search - Canada">Trademark Clearance Search - Canada</option>
                          <option value="Trademark Clearance Search - US">Trademark Clearance Search - US</option>
                          <option value="Trademark Clearance Search - EU">Trademark Clearance Search - EU</option>
                          <option value="Trademark Clearance Search - Other jurisdiction">Trademark Clearance Search - Other jurisdiction</option>
                          <option value="Other">Other</option>
                        </select>
                      }
                      {
                        isTier2 && category === "Agreements" &&
                        <select className={`${inputClasses} flex grow break-word self-center max-w-full overflow-hidden whitespace-normal`} id="task" value={task} name="task" style={{wordWrap: "break-word"}} onChange={handleTaskChange}>
                          <option className="!text-cSecondaryGreen" selected={true} disabled>Select a Task</option>
                          <option value="Review of IP clauses/IP ownership">Review of IP clauses/IP ownership</option>
                          <option value="Drafting for IP clauses/IP ownership">Drafting for IP clauses/IP ownership</option>
                          <option value="Other">Other</option> 
                        </select>
                      }
                      {
                        isTier2 && category === "Trade Secret" &&
                        <select className={`${inputClasses} flex grow break-word self-center max-w-full overflow-hidden whitespace-normal`} id="task" value={task} name="task" style={{wordWrap: "break-word"}} onChange={handleTaskChange}>
                          <option className="!text-cSecondaryGreen" selected={true} disabled>Select a Task</option>
                          <option value="Trade Secret Protection Plan">Trade Secret Protection Plan</option>
                          <option value="Other">Other</option> 
                        </select>
                      }
                      {
                        isTier2 && category === "Other" &&
                        <select className={`${inputClasses} flex grow break-word self-center max-w-full overflow-hidden whitespace-normal`} id="task" value={task} name="task" style={{wordWrap: "break-word"}} onChange={handleTaskChange}>
                          <option className="!text-cSecondaryGreen" selected={true} disabled>Select a Task</option>
                          <option value="Other">Other</option> 
                        </select>
                      }
                      {
                        !isTier2 && category === "Patent Filing" &&
                        <select className={`${inputClasses} flex grow break-word self-center max-w-full overflow-hidden whitespace-normal`} id="task" value={task} name="task" style={{wordWrap: "break-word"}} onChange={handleTaskChange}>
                          <option className="!text-cSecondaryGreen" selected={true} disabled>Select a Task</option>
                          <option value="Patent Filing, including initial drafting - Canada">Patent Filing, including initial drafting - Canada</option>
                          <option value="Patent Filing, regular application, including initial drafting - US">Patent Filing, regular application, including initial drafting - US</option>
                          <option value="Patent Filing, including drafting - EP (EU)">Patent Filing, including drafting - EP (EU)</option>
                          <option value="Patent Filing - PCT">Patent Filing - PCT</option>
                          <option value="Patent Filing, provisional application - US">Patent Filing, provisional application - US</option>
                          <option value="Other">Other</option>
                        </select>
                      }
                      {
                        !isTier2 && category === "Patent Conversion" &&
                        <select className={`${inputClasses} flex grow break-word self-center max-w-full overflow-hidden whitespace-normal`} id="task" value={task} name="task" style={{wordWrap: "break-word"}} onChange={handleTaskChange}>
                          <option className="!text-cSecondaryGreen" selected={true} disabled>Select a Task</option>
                          <option value="Converting PCT to CA national filing">Converting PCT to CA national filing</option>
                          <option value="Convert PCT to US national filing">Convert PCT to US national filing</option>
                          <option value="Converting US provisional to regular US application">Converting US provisional to regular US application</option>
                          <option value="Converting US provisional to PCT">Converting US provisional to PCT</option>
                          <option value="Converting US provisional to other national filing">Converting US provisional to other national filing</option>
                          <option value="Other">Other</option>
                        </select>
                      }
                      {
                        !isTier2 && category === "Patent Prosecution" &&
                        <select className={`${inputClasses} flex grow break-word self-center max-w-full overflow-hidden whitespace-normal`} id="task" value={task} name="task" style={{wordWrap: "break-word"}} onChange={handleTaskChange}>
                          <option className="!text-cSecondaryGreen" selected={true} disabled>Select a Task</option>
                          <option value="Patent Prosecution - Responding to Office Action">Patent Prosecution - Responding to Office Action</option>
                          <option value="Paying Notice of Allowance for Patent - CA">Paying Notice of Allowance for Patent - CA</option>
                          <option value="Paying Notice of Allowance for Patent - US">Paying Notice of Allowance for Patent - US</option>
                          <option value="Paying Notice of Allowance for Patent - EP (EU)">Paying Notice of Allowance for Patent - EP (EU)</option>
                          <option value="Paying Notice of Allowance for Patent - Other jurisdiction">Paying Notice of Allowance for Patent - Other jurisdiction</option>
                          <option value="Other">Other</option>
                        </select>
                      }
                      {
                        !isTier2 && category === "Trademark" &&
                        <select className={`${inputClasses} flex grow break-word self-center max-w-full overflow-hidden whitespace-normal`} id="task" value={task} name="task" style={{wordWrap: "break-word"}} onChange={handleTaskChange}>
                          <option className="!text-cSecondaryGreen" selected={true} disabled>Select a Task</option>
                          <option value="Trademark Filing - Canada">Trademark Filing - Canada</option>
                          <option value="Trademark Filing - US">Trademark Filing - US</option>
                          <option value="Trademark Filing - Other jurisdiction">Trademark Filing - Other jurisdiction</option>
                          <option value="Other">Other</option>
                        </select>
                      }
                      {
                        !isTier2 && category === "Agreements" &&
                        <select className={`${inputClasses} flex grow break-word self-center max-w-full overflow-hidden whitespace-normal`} id="task" value={task} name="task" style={{wordWrap: "break-word"}} onChange={handleTaskChange}>
                          <option className="!text-cSecondaryGreen" selected={true} disabled>Select a Task</option>
                          <option value="Review and/or drafting Licensing agreement">Review and/or drafting Licensing agreement</option>
                          <option value="Other">Other</option>
                        </select>
                      }
                      {
                        !isTier2 && category === "Design Patent/Industrial Design" &&
                        <select className={`${inputClasses} flex grow break-word self-center max-w-full overflow-hidden whitespace-normal`} id="task" value={task} name="task" style={{wordWrap: "break-word"}} onChange={handleTaskChange}>
                          <option className="!text-cSecondaryGreen" selected={true} disabled>Select a Task</option>
                          <option value="Design Patent/Industrial Design Application - US">Design Patent/Industrial Design Application - US</option>
                          <option value="Design Patent/Industrial Design Application - Other jurisdiction">Design Patent/Industrial Design Application - Other jurisdiction</option>
                          <option value="Other">Other</option>
                        </select>
                      }
                      {
                        !isTier2 && category === "Other" &&
                        <select className={`${inputClasses} flex grow break-word self-center max-w-full overflow-hidden whitespace-normal`} id="task" value={task} name="task" style={{wordWrap: "break-word"}} onChange={handleTaskChange}>
                          <option className="!text-cSecondaryGreen" selected={true} disabled>Select a Task</option>
                          <option value="Open Source Review and Inventory">Open Source Review and Inventory</option>
                          <option value="Other">Other</option>
                        </select>
                      }
                    </div>
                  </div>
                  <div className="!h-full !min-h-full" style={{ width: '24%', display: 'inline-block' }}>
                    <label className="font-semibold [&>a]:underline [&>a]:text-text/70 [&>a]:hover:text-text hidden" htmlFor="taskDescription">Description:</label>
                    <textarea wrap="soft" className={`${inputClasses} !bodySmaller !h-full !min-h-full`} id="taskDescription" placeholder="Task description" value={taskDescription} onChange={handleTaskDescriptionChange}></textarea>
                  </div>
                  <div className="h-full " style={{ width: '24%', display: 'inline-block' }}>
                    <label className="font-semibold [&>a]:underline [&>a]:text-text/70 [&>a]:hover:text-text hidden" htmlFor="deliverable">Deliverable:</label>
                    <textarea wrap="soft" className={`${inputClasses} !h-full !min-h-full`} id="deliverable" placeholder="Task deliverables" value={deliverable} onChange={handleDeliverableChange} />
                  </div>
                  {/* <div className="h-full " style={{ width: '12%', display: 'inline-block' }}>
                    {!isLumpsum &&
                    <div>
                      <label className="font-semibold [&>a]:underline [&>a]:text-text/70 [&>a]:hover:text-text hidden" htmlFor="effort">Effort:</label>
                      <input className="bg-background border-none w-full flex" type="number" id="effort" placeholder="###" onChange={handleEffortChange} />
                    </div>
                    }
                    <div className="flex gap-2 items-center">
                    <label className="bodySmaller flex gap-2 items-center mt-2">
                      <input 
                        type="checkbox" 
                        checked={isLumpsum}
                        onChange={handleLumpsumChange}
                      />
                      Payment is a one time fee?
                    </label>
                    </div>
                  </div> */}
                  <div className="h-full " style={{ width: '12%', display: 'inline-block' }}>
                    <DatePicker 
                      className={" w-full text-text bg-background"}
                      selected={paymentDate}
                      id={"Deliverable Date"}
                      scrollableYearDropdown={true}
                      showYearDropdown
                      yearDropdownItemNumber={115}
                      onChange={handleDateChange}
                      minDate={new Date()}
                      maxDate={finalPaymentDate ? new Date(finalPaymentDate) : null}
                    />
                  </div>
                  <div className="h-full" style={{ width: '24%', display: 'inline-block' }}>
                    <form>
                      <div className="flex flex-col">
                      <label aria-label="Cost Description" className="mb-2 [&>a]:underline [&>a]:text-text/70 [&>a]:hover:text-text" htmlFor="itemDescription">Description:</label>
                      <input className={`${inputClasses}`} type="text" placeholder="Cost description" id="itemDescription" value={itemDescription} onChange={handleItemDescriptionChange} />
                      </div>
                      <div className="flex flex-col">
                    {!isLumpsum &&
                    <div className="mt-2 flex flex-col">
                      <label className="mb-2" htmlFor="effort">Effort (Hours):</label>
                      <input className={`${inputClasses}`} type="number" id="effort" placeholder="###" value={effort} onChange={handleEffortChange} />
                    </div>
                    }
                    <div className="flex gap-2 items-center">
                    <label className="bodySmaller flex gap-2 items-center mt-2">
                      <input 
                        type="checkbox" 
                        checked={isLumpsum}
                        onChange={handleLumpsumChange}
                      />
                      Payment is a fixed rate
                    </label>
                    </div>
                  </div>
                      {!isLumpsum &&
                      <div className="flex flex-col mt-2">
                        <label className="[&>a]:underline [&>a]:text-text/70 [&>a]:hover:text-text mb-2" htmlFor="amount">Hourly Rate:</label>
                        <input className={`${inputClasses}`} type="number" placeholder="Hourly Rate"  id="amount" value={hourlyRate} onChange={handleItemHourlyChange} />
                      </div>
                      }
                      <div className="flex flex-col mt-2">
                        <label className="[&>a]:underline [&>a]:text-text/70 [&>a]:hover:text-text mb-2" htmlFor="amount">Amount (Pre-Tax):</label>
                        <input className={`${inputClasses}`} type="number" placeholder="Amount" disabled={!isLumpsum} id="amount" value={amount} onChange={handleAmountChange} />
                      </div>
                      <div className="flex flex-col mt-2">
                        <label className="&>a]:underline [&>a]:text-text/70 [&>a]:hover:text-text mb-2" htmlFor="tax">Tax:</label>
                        <select className={`${inputClasses}`} placeholder="Amount (pre-tax)" id="tax" value={tax} onChange={handleTaxChange}>
                        <option value="" disabled>Select a Tax Rate</option>
                          <option value="0">0%</option>
                          <option value="0.05">5%</option>
                          <option value="0.13">13%</option>
                        </select>
                      </div>
                      <div className="flex">
                        <button
                          className="flex gap-2 w-full items-center mt-2" type="button" onClick={handleAddExpense}>
                          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"><path d="M12 24C5.38247 24 0 18.6173 0 12C0 5.38274 5.38274 0 12 0C18.6173 0 24 5.38274 24 12C24 18.6173 18.6173 24 12 24ZM12 1.34831C6.1262 1.34831 1.34831 6.12642 1.34831 12C1.34831 17.8736 6.12642 22.6517 12 22.6517C17.8736 22.6517 22.6517 17.8736 22.6517 12C22.6517 6.12642 17.8736 1.34831 12 1.34831Z" fill="#1A2E25"/><path d="M12.0003 17.3279C11.6274 17.3279 11.3262 17.0266 11.3262 16.6537V7.34603C11.3262 6.97314 11.6274 6.67188 12.0003 6.67188C12.3732 6.67188 12.6745 6.97314 12.6745 7.34603V16.6602C12.6745 17.0268 12.3732 17.3279 12.0003 17.3279Z" fill="#1A2E25"/><path d="M16.6537 12.6745H7.34603C6.97314 12.6745 6.67188 12.3732 6.67188 12.0003C6.67188 11.6274 6.97314 11.3262 7.34603 11.3262H16.6602C17.0331 11.3262 17.3343 11.6274 17.3343 12.0003C17.3343 12.3732 17.0266 12.6745 16.6537 12.6745Z" fill="#1A2E25"/></svg>  
                          <p className="underline bodyLarger">Add Another Cost Item</p>
                        </button>
                      </div>
                    </form>
                    {expenses.length > 0 &&
                    <ul className="bg-cBlue w-full">
                      {expenses.map((expense, index) => (
                        <li key={expense.expenseId} className={index === 0 ? `expenseLi w-full` : "expenseLi border-top-[1px] border-cSage"}>
                          <div className="w-full flex justify-between">
                            {expense.itemDescription}
                            <button className="underline" onClick={() => removeExpense(expense.expenseId)}>Remove</button>
                          </div> 
                          {
                            !expense.isLumpsum &&
                            <div className="flex w-full bodySmaller">
                              <span className="w-1/3">Hours: {expense.effort}</span>
                              <span className="w-2/3">Hourly Rate: ${expense.hourlyRate}</span>
                            </div>                           
                          }
                          <div className="flex w-full bodySmaller">
                            <span className="w-1/3">$ {expense.amount}</span>
                            <span className="w-2/3">{expense.tax === "0" ? "No Tax" : expense.tax === "0.05" ? `5% tax =  $ ${((parseFloat(expense.amount) * (parseFloat(expense.tax))) + parseFloat(expense.amount)).toFixed(2)}` : `13% tax =  $ ${((parseFloat(expense.amount) * (parseFloat(expense.tax))) + parseFloat(expense.amount)).toFixed(2)}`}  </span>
                          </div>
                        </li>
                      ))}
                    </ul>
                    }
                  </div>
                </div>
              </div>
            }
            {
              isEditing && editingItem.hasOwnProperty('paymentType') && editPayType === "milestone" &&
              <div id="MilestoneItemCont" style={{ width: 'calc(100% - 64px)' }} className="mx-[32px] sowAddingCont !flex-row gap-2 items-center!">
                <div className="flex items-center" style={{ width: '64%', display: 'inline-flex' }}>
                  <p className="font-semibold">Progress Milestone Payment</p>
                </div>
                  <div className=" " style={{ width: '12%', display: 'inline-block' }}>
                    <DatePicker 
                      className={inputClasses}
                      selected={paymentDate}
                      id={"MilestonePaymentDate"}
                      scrollableYearDropdown={true}
                      showYearDropdown
                      yearDropdownItemNumber={115}
                      onChange={handlePaymentDateChange}
                      minDate={sowItemArray[0].itemDate}
                    />   
                  </div>
                <div className="flex items-center"  style={{ width: '21%', display: 'inline-flex' }}>
                  {/* <p className=""><span className="fonr-semibold">Amount:</span> ${currentTotal.toFixed(2)}</p> */}
                </div>
              </div>
            }
            {
              isTier2 && isEditing && editingItem.hasOwnProperty('paymentType') && editPayType === "final" &&
              <div id="FinalAddingItemCont" style={{ width: 'calc(100% - 64px)' }} className="mx-[32px] sowAddingCont !flex-row gap-2 items-center!">
                <div className="h-full items-center" style={{ width: '64%', display: 'inline-flex' }}>
                  <p className="flex grow break-word font-normal text-text/80 self-center capitalize">Final Payment Date</p>
                </div>
                  <div className="h-full " style={{ width: '12%', display: 'inline-flex' }}>               
                    <DatePicker 
                      title={"Final Payment Date"}
                      className={inputClasses}
                      selected={paymentDate}
                      id={"FinalPaymentDate"}
                      scrollableYearDropdown={true}
                      showYearDropdown
                      yearDropdownItemNumber={115}
                      onChange={handlePaymentDateChange}
                      minDate={sowItemArray[sowItemArray.length - 1].itemDate}
                    />
                  </div>
              </div>
            }
            {
              !isTier2 && isEditing && editingItem.hasOwnProperty('paymentType') && editPayType === "final" &&
              <div id="FinalAddingItemCont" style={{ width: 'calc(100% - 64px)' }} className="mx-[32px] sowAddingCont gap-2 !items-center">
                <div className="w-full">
                  <div className=" " style={{ width: '64%', display: 'inline-flex' }}>
                    <p className="font-semibold">Final Payment Date</p>
                  </div>
                  <div className=" " style={{ width: '12%', display: 'inline-flex' }}>               
                      <DatePicker 
                        title={"Final Payment Date"}
                        className={inputClasses}
                        selected={finalPayDateMin > paymentDate ? finalPayDateMin : paymentDate}
                        id={"FinalPaymentDate"}
                        scrollableYearDropdown={true}
                        showYearDropdown
                        yearDropdownItemNumber={115}
                        onChange={handlePaymentDateChange}
                        minDate={sowItemArray[sowItemArray.length - 1].itemDate}
                      />
                    </div>
                  </div>
                  <div className="w-full mt-4">
                    <div className="items-center" style={{ width: '64%', display: 'inline-flex' }}>
                      <p className="font-semibold">Co-Invest Payment Date</p>
                    </div>
                    <div className="" style={{ width: '12%', display: 'inline-flex' }}>
                      <DatePicker 
                        title={"Co-Investment Payment Date"}
                        className={inputClasses}
                        selected={coPaymentDate}
                        id={"CoInvestPaymentDate"}
                        scrollableYearDropdown={true}
                        showYearDropdown
                        yearDropdownItemNumber={115}
                        onChange={handleCoPaymentDateChange}
                        maxDate={sowItemArray[0].itemDate}
                      />
                    </div>
                  </div>
              </div>
            }
            <div className="flex-row-reverse flex mt-6">
              {
                isEditing ?
                <div className="mr-[56px]">
                  <Button
                    buttonText="Save Edits"
                    actionHandler={handleSaveEdit}
                    // disabled={}
                  />
                </div>
                :
                addingItem ?
                <div className="mr-[56px]">
                  <Button
                    buttonText="Save Action Item"
                    actionHandler={addToItemsArray}
                    disabled={deliverable && taskDescription && effort && expenses.length > 0 && category || deliverable && taskDescription && effort && hourlyRate && amount && itemDescription && tax && category || deliverable && amount && tax && taskDescription && isLumpsum && category ? false : true}
                  />
                </div>
                :
                // isAddingMilestone ?
                // <div className="mr-[56px]">
                //   <Button
                //     buttonText="Add Milestone Payment"
                //     actionHandler={() => addToPaymentArray("milestone")}
                //   />
                // </div>
                // :
                isAddingFinal ?
                <div className="mr-[56px]">
                  <Button
                    buttonText="Add Final Payment"
                    actionHandler={() => addToPaymentArray("final")}
                  />
                </div>
                :
                <div className="flex gap-8 mx-[56px] w-full">
                  <Button
                    buttonText="Add Action Item"
                    actionHandler={() => addingItemDisplay()}
                    style={"mr-2"}
                    disabled={editRequestItemDisabledBoolean ? false : isAddingMilestone || isAddingFinal || paymentArray.some(item => item.paymentType === 'final')}
                  />
                  {/* {!isTier2 &&
                  <Button 
                    buttonText="Add Milestone Payment"
                    actionHandler={() => setIsAddingMilestone(true)}
                    style={"mr-2"}
                    disabled={isAddingMilestone || isAddingFinal || paymentDisabled} 
                  />
                  } */}
                  <Button 
                    buttonText={"Add Final Payment Date"}
                    actionHandler={() => setIsAddingFinal(true)}
                    disabled={isAddingMilestone || isAddingFinal || paymentDisabled}
                  />
                </div>
              }
            </div>
        </div>
      </div>
      <Modal 
          isOpen={isModalOpen}
          closeModal={() => closeModalFunc()}
          modalHeader={``}
          contentLabel={``}
          modalHTML={
              <div className="w flex flex-col ">
                {
                  viewingStartupFeedback &&
                  <div className="flex flex-col ">
                    <h2 className="text-center mb-4">Startup Feedback</h2>
                    {startupFeedbackHtml}
                  </div>
                }
                {
                  viewingAdminFeedback &&
                  <div className="flex flex-col ">
                    <h2 className="text-center mb-4">Admin Feedback</h2>
                    {adminFeedbackHtml}
                  </div>
                }
                {
                !viewingStartupFeedback && !viewingAdminFeedback &&
                  <div className="flex flex-col ">
                    <h2 className="text-center mb-4">SoW Preview</h2>
                    <div className="flex flex-col w-full mt-4">
                      <div className="w-full font-medium flex gap-2 bg-backgrounds text-text">
                        <div className="h-full " style={{ width: '15%', display: 'inline-block' }}>
                          <p className="flex grow font-semibold break-all text-text/80 self-center capitalize">Category</p>
                        </div>
                        <div className="h-full " style={{ width: '24%', display: 'inline-block' }}>
                          <p className="flex grow font-semibold break-all text-text/80 self-center capitalize">Task Description</p>
                        </div>
                        <div className="h-full " style={{ width: '24%', display: 'inline-block' }}>
                          <p className="flex grow font-semibold break-all text-text/80 self-center capitalize">Deliverable</p>
                        </div>
                        {/* <div className="h-full " style={{ width: '12%', display: 'inline-block' }}>
                            <p className="flex grow font-semibold break-all text-text/80 self-center capitalize">Effort (hours)</p>
                        </div> */}
                        <div className="h-full " style={{ width: '12%', display: 'inline-block' }}>
                          <p className="flex grow font-semibold break-all text-text/80 self-center capitalize">Date</p>
                        </div>
                        <div className="h-full " style={{ width: '24%', display: 'inline-block' }}>
                          <p className="flex grow font-semibold break-all text-text/80 self-center capitalize">Cost Breakdown ($ CAD)</p>
                        </div>
                      </div>
                    </div>
                    {sowItemTableHtml}
                    <div className="mx-auto my-8">
                      <Button
                        buttonText="Submit SoW for Company Review"
                        buttonType="primary"
                        actionHandler={() => submitSow()}
                      />
                    </div>
                  </div>
                }
              </div>
          }
          style={{
            content: {
              top: '50%',
              left: '50%',
              right: 'auto',
              bottom: 'auto',
              marginRight: '-50%',
              transform: 'translate(-50%, -50%)',
              minWidth: '300px',
              width: `${viewingStartupFeedback ? "fit-content" : 'calc(100% - 112px'}`,
              height: `${viewingStartupFeedback ? "fit-content" : "90vh"}`,
              overflow: "auto",
              background: "background",
            }
          }}
        />
    </div>
  )
}

export default CreateSOW